/* tslint:disable */
/* eslint-disable */
/**
 * Coriolis.OTFP.API.Kosmos
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'addressLine1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'addressLine2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {AddressSourceDto}
     * @memberof AddressDto
     */
    'source'?: AddressSourceDto;
}


/**
 * source of company address. AddressSource.Unknown: The source is unknown.user-input: from SME user input from questionnairebvd-company-detail-address: address from bvd-company-detail record
 * @export
 * @enum {string}
 */

export const AddressSourceDto = {
    Unknown: 'unknown',
    UserInput: 'user-input',
    BvdCompanyDetailAddress: 'bvd-company-detail-address'
} as const;

export type AddressSourceDto = typeof AddressSourceDto[keyof typeof AddressSourceDto];


/**
 * 
 * @export
 * @interface AdverseNewsMonthCountDto
 */
export interface AdverseNewsMonthCountDto {
    /**
     * 
     * @type {string}
     * @memberof AdverseNewsMonthCountDto
     */
    'monthLabel': string;
    /**
     * 
     * @type {number}
     * @memberof AdverseNewsMonthCountDto
     */
    'count': number;
}
/**
 * The affinity (positive, negative, neutral, ambiguous) for this piece of information
 * @export
 * @enum {string}
 */

export const Affinity = {
    Neutral: 'neutral',
    Negative: 'negative',
    Warning: 'warning',
    Positive: 'positive',
    Unscored: 'unscored'
} as const;

export type Affinity = typeof Affinity[keyof typeof Affinity];


/**
 * 
 * @export
 * @interface AuditLogCreditDto
 */
export interface AuditLogCreditDto {
    /**
     * 
     * @type {string}
     * @memberof AuditLogCreditDto
     */
    'eventId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuditLogCreditDto
     */
    'creditChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditLogCreditDto
     */
    'creditCountAfter'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuditLogCreditDto
     */
    'publicDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogCreditDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogCreditDto
     */
    'organisationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogCreditDto
     */
    'scoredCompanyId'?: string | null;
}
/**
 * 
 * @export
 * @interface AuditLogCreditDtoQueryResultDto
 */
export interface AuditLogCreditDtoQueryResultDto {
    /**
     * 
     * @type {Array<AuditLogCreditDto>}
     * @memberof AuditLogCreditDtoQueryResultDto
     */
    'items'?: Array<AuditLogCreditDto> | null;
    /**
     * 
     * @type {number}
     * @memberof AuditLogCreditDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditLogCreditDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditLogCreditDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface AuditLogDto
 */
export interface AuditLogDto {
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'aadUserId': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'organisationId': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'controllerName': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'actionName': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'eventName': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'metadata'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'updated'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof AuditLogDto
     */
    'user'?: UserDto;
}
/**
 * 
 * @export
 * @interface AuditLogDtoQueryResultDto
 */
export interface AuditLogDtoQueryResultDto {
    /**
     * 
     * @type {Array<AuditLogDto>}
     * @memberof AuditLogDtoQueryResultDto
     */
    'items'?: Array<AuditLogDto> | null;
    /**
     * 
     * @type {number}
     * @memberof AuditLogDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditLogDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditLogDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface AuditLogSummaryDto
 */
export interface AuditLogSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof AuditLogSummaryDto
     */
    'eventName': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSummaryDto
     */
    'actionName': string;
    /**
     * 
     * @type {number}
     * @memberof AuditLogSummaryDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface CapexOpexClobDto
 */
export interface CapexOpexClobDto {
    /**
     * 
     * @type {boolean}
     * @memberof CapexOpexClobDto
     */
    'displaySection'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CapexOpexClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CapexOpexClobDto
     */
    'spendPercentTurnover'?: number;
    /**
     * 
     * @type {number}
     * @memberof CapexOpexClobDto
     */
    'spendPercentCapEx'?: number;
    /**
     * 
     * @type {number}
     * @memberof CapexOpexClobDto
     */
    'spendPercentOpEx'?: number;
}
/**
 * A collection of answers for a section
 * @export
 * @interface CheckQuestionResponseDto
 */
export interface CheckQuestionResponseDto {
    /**
     * Section alias
     * @type {string}
     * @memberof CheckQuestionResponseDto
     */
    'sectionAlias': string;
    /**
     * Optional sub-section alias
     * @type {string}
     * @memberof CheckQuestionResponseDto
     */
    'subSectionAlias'?: string;
    /**
     * Company ID
     * @type {string}
     * @memberof CheckQuestionResponseDto
     */
    'companyId'?: string | null;
    /**
     * 
     * @type {CheckQuestionResponseDtoQuestionResponse}
     * @memberof CheckQuestionResponseDto
     */
    'questionResponse': CheckQuestionResponseDtoQuestionResponse;
    /**
     * Question responses provided as context
     * @type {Array<CheckQuestionResponseDtoValidationContextInner>}
     * @memberof CheckQuestionResponseDto
     */
    'validationContext': Array<CheckQuestionResponseDtoValidationContextInner>;
}
/**
 * @type CheckQuestionResponseDtoQuestionResponse
 * Question response
 * @export
 */
export type CheckQuestionResponseDtoQuestionResponse = QuestionResponseBoolDto | QuestionResponseDateDto | QuestionResponseDto | QuestionResponseFileDto | QuestionResponseMultipleChoiceDto | QuestionResponseNumberDto | QuestionResponseTabularChoiceDto | QuestionResponseTextDto | QuestionResponseTextListDto;

/**
 * @type CheckQuestionResponseDtoValidationContextInner
 * Question response (abstract)
 * @export
 */
export type CheckQuestionResponseDtoValidationContextInner = QuestionResponseBoolDto | QuestionResponseDateDto | QuestionResponseDto | QuestionResponseFileDto | QuestionResponseMultipleChoiceDto | QuestionResponseNumberDto | QuestionResponseTabularChoiceDto | QuestionResponseTextDto | QuestionResponseTextListDto;

/**
 * 
 * @export
 * @interface CommodityCodeDto
 */
export interface CommodityCodeDto {
    /**
     * 
     * @type {string}
     * @memberof CommodityCodeDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommodityCodeDto
     */
    'commodity'?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyBaseDto
 */
export interface CompanyBaseDto {
    /**
     * True if this company is owned by either the current user or service user
     * @type {boolean}
     * @memberof CompanyBaseDto
     */
    'owned'?: boolean;
    /**
     * 
     * @type {CompanyOnboardingState}
     * @memberof CompanyBaseDto
     */
    'onboardingStatus'?: CompanyOnboardingState;
    /**
     * 
     * @type {string}
     * @memberof CompanyBaseDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBaseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyBaseDto
     */
    'companyNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyBaseDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyBaseDto
     */
    'currency'?: string | null;
}


/**
 * 
 * @export
 * @interface CompanyDetailedDto
 */
export interface CompanyDetailedDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDto
     */
    'score'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'lastUpdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'statusInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'lastScoredAt'?: string;
    /**
     * 
     * @type {Array<EntityScoreDto>}
     * @memberof CompanyDetailedDto
     */
    'scores'?: Array<EntityScoreDto> | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof CompanyDetailedDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {CompanyScoringState}
     * @memberof CompanyDetailedDto
     */
    'scoringState'?: CompanyScoringState;
    /**
     * 
     * @type {Array<CompanyIndustryCodeDto>}
     * @memberof CompanyDetailedDto
     */
    'companyIndustryCodes'?: Array<CompanyIndustryCodeDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDto
     */
    'esgScore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDto
     */
    'envScore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDto
     */
    'socScore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDto
     */
    'govScore'?: number | null;
    /**
     * 
     * @type {Array<ReportHistoryDto>}
     * @memberof CompanyDetailedDto
     * @deprecated
     */
    'reportHistory'?: Array<ReportHistoryDto> | null;
    /**
     * 
     * @type {Array<RegistrationNumberDto>}
     * @memberof CompanyDetailedDto
     */
    'registrationNumbers'?: Array<RegistrationNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     * @deprecated
     */
    'sourceCompanyId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'companyPlatformDiscriminator'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDto
     */
    'searchSortOrder'?: number;
    /**
     * 
     * @type {OrganisationAssignmentDto}
     * @memberof CompanyDetailedDto
     */
    'smartGovernanceAssignment'?: OrganisationAssignmentDto;
    /**
     * 
     * @type {CompanySizeDto}
     * @memberof CompanyDetailedDto
     */
    'companySize'?: CompanySizeDto;
    /**
     * True if this company is owned by either the current user or service user
     * @type {boolean}
     * @memberof CompanyDetailedDto
     */
    'owned'?: boolean;
    /**
     * 
     * @type {CompanyOnboardingState}
     * @memberof CompanyDetailedDto
     */
    'onboardingStatus'?: CompanyOnboardingState;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDto
     */
    'companyNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailedDto
     */
    'currency'?: string | null;
}


/**
 * 
 * @export
 * @interface CompanyDetailedDtoQueryResultDto
 */
export interface CompanyDetailedDtoQueryResultDto {
    /**
     * 
     * @type {Array<CompanyDetailedDto>}
     * @memberof CompanyDetailedDtoQueryResultDto
     */
    'items'?: Array<CompanyDetailedDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailedDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface CompanyDto
 */
export interface CompanyDto {
    /**
     * 
     * @type {CompanySizeDto}
     * @memberof CompanyDto
     */
    'companySize'?: CompanySizeDto;
    /**
     * True if this company is owned by either the current user or service user
     * @type {boolean}
     * @memberof CompanyDto
     */
    'owned'?: boolean;
    /**
     * 
     * @type {CompanyOnboardingState}
     * @memberof CompanyDto
     */
    'onboardingStatus'?: CompanyOnboardingState;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'companyNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'currency'?: string | null;
}


/**
 * 
 * @export
 * @interface CompanyIndustryCodeDto
 */
export interface CompanyIndustryCodeDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyIndustryCodeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyIndustryCodeDto
     */
    'companyId'?: string;
    /**
     * 
     * @type {EIndustryCodeTypeDto}
     * @memberof CompanyIndustryCodeDto
     */
    'industryCodeType'?: EIndustryCodeTypeDto;
    /**
     * 
     * @type {string}
     * @memberof CompanyIndustryCodeDto
     */
    'industryCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyIndustryCodeDto
     */
    'description'?: string | null;
    /**
     * True if this is the primary code of this company
     * @type {boolean}
     * @memberof CompanyIndustryCodeDto
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {EIndustryCodeProviderDto}
     * @memberof CompanyIndustryCodeDto
     */
    'provider'?: EIndustryCodeProviderDto;
}


/**
 * 
 * @export
 * @interface CompanyListCompanyDto
 */
export interface CompanyListCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyListCompanyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListCompanyDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListCompanyDto
     */
    'registrationNumbers': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListCompanyDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListCompanyDto
     */
    'companyListId'?: string;
    /**
     * 
     * @type {CompanyScoreDto}
     * @memberof CompanyListCompanyDto
     */
    'company'?: CompanyScoreDto;
    /**
     * 
     * @type {KosmosReportSnapshotDto}
     * @memberof CompanyListCompanyDto
     */
    'kosmosReportSnapshotDto'?: KosmosReportSnapshotDto;
    /**
     * 
     * @type {VerificationStatusDto}
     * @memberof CompanyListCompanyDto
     */
    'verificationStatus'?: VerificationStatusDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyListCompanyDto
     */
    'matchedCompanyIds'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyListCompanyDto
     */
    'position'?: number;
}


/**
 * 
 * @export
 * @interface CompanyListCompanyDtoQueryResultDto
 */
export interface CompanyListCompanyDtoQueryResultDto {
    /**
     * 
     * @type {Array<CompanyListCompanyDto>}
     * @memberof CompanyListCompanyDtoQueryResultDto
     */
    'items'?: Array<CompanyListCompanyDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyListCompanyDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyListCompanyDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyListCompanyDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface CompanyListDto
 */
export interface CompanyListDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'updated': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'organisationId'?: string;
    /**
     * 
     * @type {OrganisationDto}
     * @memberof CompanyListDto
     */
    'organisation'?: OrganisationDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDto
     */
    'companyCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDto
     */
    'companyVerifiedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDto
     */
    'companyScoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDto
     */
    'companyScoreErrorCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyListDto
     */
    'isVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'lastTriggeredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'lastScoredAt'?: string;
    /**
     * 
     * @type {Array<CompanyListCompanyDto>}
     * @memberof CompanyListDto
     */
    'companyListCompanies'?: Array<CompanyListCompanyDto> | null;
}
/**
 * 
 * @export
 * @interface CompanyListDtoQueryResultDto
 */
export interface CompanyListDtoQueryResultDto {
    /**
     * 
     * @type {Array<CompanyListDto>}
     * @memberof CompanyListDtoQueryResultDto
     */
    'items'?: Array<CompanyListDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * The extent to which a given company is onboarded in Atlas
 * @export
 * @enum {string}
 */

export const CompanyOnboardingState = {
    PreOnboarded: 'PreOnboarded',
    FullyOnboarded: 'FullyOnboarded'
} as const;

export type CompanyOnboardingState = typeof CompanyOnboardingState[keyof typeof CompanyOnboardingState];


/**
 * 
 * @export
 * @interface CompanyPolicyClobDto
 */
export interface CompanyPolicyClobDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyPolicyClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {Affinity}
     * @memberof CompanyPolicyClobDto
     */
    'affinity'?: Affinity;
}


/**
 * 
 * @export
 * @interface CompanyQuestionAnswerOptionDto
 */
export interface CompanyQuestionAnswerOptionDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerOptionDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyQuestionAnswerOptionDto
     */
    'values'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CompanyQuestionAnswerPairDto
 */
export interface CompanyQuestionAnswerPairDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'question'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'questionAlias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'section'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'isSatisfied'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'answer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'fileUrl'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'answerList'?: Array<string> | null;
    /**
     * 
     * @type {Array<CompanyQuestionAnswerOptionDto>}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'optionsList'?: Array<CompanyQuestionAnswerOptionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'answerDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestionAnswerPairDto
     */
    'questionType'?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyQuestionnaireDetailDto
 */
export interface CompanyQuestionnaireDetailDto {
    /**
     * 
     * @type {Array<CompanyQuestionAnswerPairDto>}
     * @memberof CompanyQuestionnaireDetailDto
     */
    'companyQuestionAnswerPairDtos'?: Array<CompanyQuestionAnswerPairDto> | null;
}
/**
 * 
 * @export
 * @interface CompanyScoreDto
 */
export interface CompanyScoreDto {
    /**
     * 
     * @type {CompanyScoringState}
     * @memberof CompanyScoreDto
     */
    'scoringState'?: CompanyScoringState;
    /**
     * 
     * @type {Array<RegistrationNumberDto>}
     * @memberof CompanyScoreDto
     */
    'externalIdentifiers'?: Array<RegistrationNumberDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyScoreDto
     */
    'esgScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyScoreDto
     */
    'statusInfo'?: string | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof CompanyScoreDto
     */
    'address'?: AddressDto;
    /**
     * True if this company is owned by either the current user or service user
     * @type {boolean}
     * @memberof CompanyScoreDto
     */
    'owned'?: boolean;
    /**
     * 
     * @type {CompanyOnboardingState}
     * @memberof CompanyScoreDto
     */
    'onboardingStatus'?: CompanyOnboardingState;
    /**
     * 
     * @type {string}
     * @memberof CompanyScoreDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyScoreDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyScoreDto
     */
    'companyNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyScoreDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyScoreDto
     */
    'currency'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CompanyScoringState = {
    NotStarted: 'NotStarted',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Error: 'Error'
} as const;

export type CompanyScoringState = typeof CompanyScoringState[keyof typeof CompanyScoringState];


/**
 * 
 * @export
 * @interface CompanySearchDto
 */
export interface CompanySearchDto {
    /**
     * 
     * @type {CompanyScoringState}
     * @memberof CompanySearchDto
     */
    'scoringState'?: CompanyScoringState;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    'lastUpdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    'statusInfo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDto
     */
    'score'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDto
     */
    'esgScore'?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof CompanySearchDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {Array<CompanyIndustryCodeDto>}
     * @memberof CompanySearchDto
     */
    'companyIndustryCodes'?: Array<CompanyIndustryCodeDto> | null;
    /**
     * 
     * @type {Array<RegistrationNumberDto>}
     * @memberof CompanySearchDto
     */
    'registrationNumbers'?: Array<RegistrationNumberDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDto
     */
    'envScore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDto
     */
    'socScore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDto
     */
    'govScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    'companyPlatformDiscriminator'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDto
     */
    'searchSortOrder'?: number;
    /**
     * 
     * @type {OrganisationAssignmentDto}
     * @memberof CompanySearchDto
     */
    'smartGovernanceAssignment'?: OrganisationAssignmentDto;
    /**
     * 
     * @type {CompanySizeDto}
     * @memberof CompanySearchDto
     */
    'companySize'?: CompanySizeDto;
    /**
     * True if this company is owned by either the current user or service user
     * @type {boolean}
     * @memberof CompanySearchDto
     */
    'owned'?: boolean;
    /**
     * 
     * @type {CompanyOnboardingState}
     * @memberof CompanySearchDto
     */
    'onboardingStatus'?: CompanyOnboardingState;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDto
     */
    'companyNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    'currency'?: string | null;
}


/**
 * 
 * @export
 * @interface CompanySearchDtoQueryResultDto
 */
export interface CompanySearchDtoQueryResultDto {
    /**
     * 
     * @type {Array<CompanySearchDto>}
     * @memberof CompanySearchDtoQueryResultDto
     */
    'items'?: Array<CompanySearchDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanySearchDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * Size of a given company. CompanySize.Unknown: The size of the company could not be determined.others: from BvD company_categoryCompanySize.SME: up to 250 employees and/or turnover less than £6.5m in last full year of trading. CompanySize.Corporate: more than 250 employees and/or turnover more than £6,500,000.
 * @export
 * @enum {string}
 */

export const CompanySize = {
    Unknown: 'Unknown',
    VeryLargeCompany: 'Very-large-company',
    LargeCompany: 'Large-company',
    MediumSizedCompany: 'Medium-sized-company',
    SmallCompany: 'Small-company'
} as const;

export type CompanySize = typeof CompanySize[keyof typeof CompanySize];


/**
 * 
 * @export
 * @interface CompanySizeDto
 */
export interface CompanySizeDto {
    /**
     * 
     * @type {CompanySize}
     * @memberof CompanySizeDto
     */
    'companySizeDescriptor'?: CompanySize;
    /**
     * The number of employees this company has
     * @type {number}
     * @memberof CompanySizeDto
     */
    'numberOfEmployees'?: number | null;
    /**
     * The annual turnover of this company
     * @type {number}
     * @memberof CompanySizeDto
     */
    'turnover'?: number | null;
}


/**
 * 
 * @export
 * @interface CompanyUserDto
 */
export interface CompanyUserDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyUserDto
     */
    'userId'?: string | null;
    /**
     * True if this company is owned by either the current user or service user
     * @type {boolean}
     * @memberof CompanyUserDto
     */
    'owned'?: boolean;
    /**
     * 
     * @type {CompanyOnboardingState}
     * @memberof CompanyUserDto
     */
    'onboardingStatus'?: CompanyOnboardingState;
    /**
     * 
     * @type {string}
     * @memberof CompanyUserDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUserDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyUserDto
     */
    'companyNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyUserDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyUserDto
     */
    'currency'?: string | null;
}


/**
 * 
 * @export
 * @interface ContentDto
 */
export interface ContentDto {
    /**
     * 
     * @type {LocaleDto}
     * @memberof ContentDto
     */
    'locale': LocaleDto;
    /**
     * 
     * @type {string}
     * @memberof ContentDto
     */
    'namespace': string;
    /**
     * 
     * @type {Array<TranslationDto>}
     * @memberof ContentDto
     */
    'translations': Array<TranslationDto>;
}
/**
 * 
 * @export
 * @interface CreateClaimDto
 */
export interface CreateClaimDto {
    /**
     * 
     * @type {string}
     * @memberof CreateClaimDto
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimDto
     */
    'companyRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimDto
     */
    'contactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimDto
     */
    'contactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimDto
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateCompanyListItemRequestDto
 */
export interface CreateCompanyListItemRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyListItemRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyListItemRequestDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyListItemRequestDto
     */
    'registrationNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateCompanyListRequestDto
 */
export interface CreateCompanyListRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyListRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyListRequestDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyListRequestDto
     */
    'organisationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyListRequestDto
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateCompanyListItemRequestDto
 */
export interface CreateOrUpdateCompanyListItemRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyListItemRequestDto
     */
    'nationalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyListItemRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyListItemRequestDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyListItemRequestDto
     */
    'registrationNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateCompanyListItemRequestDto
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateOrganisationAssignmentRequestDto
 */
export interface CreateOrganisationAssignmentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganisationAssignmentRequestDto
     */
    'organisationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganisationAssignmentRequestDto
     */
    'assignerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganisationAssignmentRequestDto
     */
    'assigneeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganisationAssignmentRequestDto
     */
    'kosmosCompanyId': string;
}
/**
 * 
 * @export
 * @interface CreateOrganisationRequestDto
 */
export interface CreateOrganisationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganisationRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganisationRequestDto
     */
    'displayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrganisationRequestDto
     */
    'hasUnlimitedCredits'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrganisationRequestDto
     */
    'isEvaluating'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateUserRequestDto
 */
export interface CreateUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    'organisationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    'userRole'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentUserDto
 */
export interface CurrentUserDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'aadUserId'?: string | null;
    /**
     * 
     * @type {UserRoleDto}
     * @memberof CurrentUserDto
     */
    'userRole': UserRoleDto;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'organisationId'?: string | null;
    /**
     * 
     * @type {OrganisationDto}
     * @memberof CurrentUserDto
     */
    'organisation'?: OrganisationDto;
    /**
     * 
     * @type {CompanyBaseDto}
     * @memberof CurrentUserDto
     */
    'company'?: CompanyBaseDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserDto
     */
    'resources'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface DiversityBreakdown
 */
export interface DiversityBreakdown {
    /**
     * 
     * @type {number}
     * @memberof DiversityBreakdown
     */
    'percentMale'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiversityBreakdown
     */
    'percentFemale'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiversityBreakdown
     */
    'percentUnknown'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiversityBreakdown
     */
    'absoluteMale'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiversityBreakdown
     */
    'absoluteFemale'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiversityBreakdown
     */
    'absoluteUnknown'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiversityBreakdown
     */
    'totalDirectors'?: number;
}
/**
 * 
 * @export
 * @interface DoubleDoubleValueTuple
 */
export interface DoubleDoubleValueTuple {
    /**
     * 
     * @type {number}
     * @memberof DoubleDoubleValueTuple
     */
    'item1'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoubleDoubleValueTuple
     */
    'item2'?: number;
}
/**
 * 
 * @export
 * @interface DualUseGoodsClobDto
 */
export interface DualUseGoodsClobDto {
    /**
     * 
     * @type {Affinity}
     * @memberof DualUseGoodsClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'entitySummaryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'entitySummaryDetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'hsCodeTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'hsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'cnCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'naceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'naceTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseGoodsClobDto
     */
    'originCodeType'?: string | null;
}


/**
 * 
 * @export
 * @interface DualUseServicesClobDto
 */
export interface DualUseServicesClobDto {
    /**
     * 
     * @type {Affinity}
     * @memberof DualUseServicesClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'entitySummaryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'entitySummaryDetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'hsCodeTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'hsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'cnCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'naceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'naceTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DualUseServicesClobDto
     */
    'originCodeType'?: string | null;
}


/**
 * CompanyIndustryCode data provider
 * @export
 * @enum {string}
 */

export const EIndustryCodeProviderDto = {
    BvD: 'BvD',
    DnB: 'DnB',
    OpenCorporates: 'OpenCorporates'
} as const;

export type EIndustryCodeProviderDto = typeof EIndustryCodeProviderDto[keyof typeof EIndustryCodeProviderDto];


/**
 * Company\'s industry code type
 * @export
 * @enum {string}
 */

export const EIndustryCodeTypeDto = {
    Nace2: 'nace2',
    UsSicV4: 'usSicV4',
    Sic: 'sic',
    Naice: 'naice'
} as const;

export type EIndustryCodeTypeDto = typeof EIndustryCodeTypeDto[keyof typeof EIndustryCodeTypeDto];


/**
 * User\'s resources based on role
 * @export
 * @enum {string}
 */

export const EPolicy = {
    SetupUser: 'SetupUser',
    SetupOrganisation: 'SetupOrganisation',
    ScoreCompany: 'ScoreCompany',
    SgRespond: 'SG_Respond',
    SgInquiry: 'SG_Inquiry',
    SgAssign: 'SG_Assign',
    FuncBulk: 'FuncBulk',
    FuncReport: 'FuncReport'
} as const;

export type EPolicy = typeof EPolicy[keyof typeof EPolicy];


/**
 * 
 * @export
 * @enum {string}
 */

export const ETransportationMode = {
    Maritime: 'Maritime',
    Rail: 'Rail',
    Road: 'Road',
    Air: 'Air'
} as const;

export type ETransportationMode = typeof ETransportationMode[keyof typeof ETransportationMode];


/**
 * 
 * @export
 * @interface EntityScoreDto
 */
export interface EntityScoreDto {
    /**
     * 
     * @type {string}
     * @memberof EntityScoreDto
     */
    'scoreAlias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityScoreDto
     */
    'scoreName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityScoreDto
     */
    'score'?: number;
    /**
     * 
     * @type {Array<ScoringInformationDto>}
     * @memberof EntityScoreDto
     */
    'information'?: Array<ScoringInformationDto> | null;
}
/**
 * 
 * @export
 * @interface EntityScoreSummaryDto
 */
export interface EntityScoreSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof EntityScoreSummaryDto
     */
    'companyId'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityScoreSummaryDto
     */
    'score'?: number | null;
    /**
     * 
     * @type {Array<EntityScoreDto>}
     * @memberof EntityScoreSummaryDto
     */
    'scores'?: Array<EntityScoreDto> | null;
}
/**
 * 
 * @export
 * @interface ErrorDto
 */
export interface ErrorDto {
    /**
     * 
     * @type {number}
     * @memberof ErrorDto
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorDto
     */
    'errorCode'?: string | null;
}
/**
 * 
 * @export
 * @interface ErrorQuestionDto
 */
export interface ErrorQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorQuestionDto
     */
    'questionAlias'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ErrorQuestionDto
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorQuestionDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorQuestionDto
     */
    'errorCode'?: string | null;
}
/**
 * The EUTaxonomy Dimension type
 * @export
 * @enum {string}
 */

export const EuTaxonomyDimension = {
    ClimateMitigation: 'climate-mitigation',
    ClimateAdaptation: 'climate-adaptation',
    Water: 'water',
    CircularEconomy: 'circular-economy',
    PollutionPrevention: 'pollution-prevention',
    Biodiversity: 'biodiversity'
} as const;

export type EuTaxonomyDimension = typeof EuTaxonomyDimension[keyof typeof EuTaxonomyDimension];


/**
 * 
 * @export
 * @interface EuTaxonomyDoNoSignificantHarmClobDto
 */
export interface EuTaxonomyDoNoSignificantHarmClobDto {
    /**
     * 
     * @type {EuTaxonomyDimension}
     * @memberof EuTaxonomyDoNoSignificantHarmClobDto
     */
    'type'?: EuTaxonomyDimension;
    /**
     * 
     * @type {string}
     * @memberof EuTaxonomyDoNoSignificantHarmClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {Affinity}
     * @memberof EuTaxonomyDoNoSignificantHarmClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {Array<NaceCodeClobDto>}
     * @memberof EuTaxonomyDoNoSignificantHarmClobDto
     */
    'naceCodes'?: Array<NaceCodeClobDto> | null;
}


/**
 * 
 * @export
 * @interface EuTaxonomyOverallClobDto
 */
export interface EuTaxonomyOverallClobDto {
    /**
     * 
     * @type {string}
     * @memberof EuTaxonomyOverallClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EuTaxonomyOverallClobDto
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof EuTaxonomyOverallClobDto
     */
    'scoreCap'?: number;
    /**
     * 
     * @type {Affinity}
     * @memberof EuTaxonomyOverallClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {EuTaxonomyDimension}
     * @memberof EuTaxonomyOverallClobDto
     */
    'type'?: EuTaxonomyDimension;
}


/**
 * 
 * @export
 * @interface FilterItemDto
 */
export interface FilterItemDto {
    /**
     * 
     * @type {string}
     * @memberof FilterItemDto
     */
    'column': string;
    /**
     * 
     * @type {string}
     * @memberof FilterItemDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GhgScopeClobDto
 */
export interface GhgScopeClobDto {
    /**
     * 
     * @type {number}
     * @memberof GhgScopeClobDto
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof GhgScopeClobDto
     */
    'scope'?: number;
    /**
     * 
     * @type {number}
     * @memberof GhgScopeClobDto
     */
    'subScope'?: number;
    /**
     * 
     * @type {string}
     * @memberof GhgScopeClobDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GhgScopeClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GhgScopeClobDto
     */
    'detail'?: Array<string> | null;
    /**
     * 
     * @type {Affinity}
     * @memberof GhgScopeClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GhgScopeClobDto
     */
    'appendixData'?: { [key: string]: string; } | null;
}


/**
 * 
 * @export
 * @interface GovernanceComplianceClobDto
 */
export interface GovernanceComplianceClobDto {
    /**
     * 
     * @type {number}
     * @memberof GovernanceComplianceClobDto
     */
    'itemOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof GovernanceComplianceClobDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GovernanceComplianceClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GovernanceComplianceClobDto
     */
    'detail'?: Array<string> | null;
    /**
     * 
     * @type {Affinity}
     * @memberof GovernanceComplianceClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {DiversityBreakdown}
     * @memberof GovernanceComplianceClobDto
     */
    'breakdown'?: DiversityBreakdown;
}


/**
 * The ICC dimension related to this piece of information
 * @export
 * @enum {string}
 */

export const IccDimension = {
    HumanSocial: 'human-social',
    Environmental: 'environmental',
    Economic: 'economic',
    SocioEconomic: 'socio-economic'
} as const;

export type IccDimension = typeof IccDimension[keyof typeof IccDimension];


/**
 * 
 * @export
 * @interface IllegalLoggingGoodsClobDto
 */
export interface IllegalLoggingGoodsClobDto {
    /**
     * 
     * @type {Affinity}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'entitySummaryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'entitySummaryDetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'hsCodeTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'hsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'cnCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'naceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'naceTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IllegalLoggingGoodsClobDto
     */
    'originCodeType'?: string | null;
}


/**
 * The platform this information is valid for
 * @export
 * @enum {string}
 */

export const InformationPlatform = {
    AllPlatforms: 'AllPlatforms',
    KosmosOnly: 'KosmosOnly',
    AtlasOnly: 'AtlasOnly'
} as const;

export type InformationPlatform = typeof InformationPlatform[keyof typeof InformationPlatform];


/**
 * 
 * @export
 * @enum {string}
 */

export const KosmosClobDataType = {
    NonKosmosData: 'non-kosmos-data',
    DualUseGoods: 'dual-use-goods',
    Sdg: 'sdg',
    DoesNoSignificantHarm: 'does-no-significant-harm',
    EuTaxonomy: 'eu-taxonomy',
    SustainableFinanceDisclosureRegulation: 'sustainable-finance-disclosure-regulation',
    Governance: 'governance',
    CapexOpex: 'capex-opex',
    CompanyPolicy: 'company-policy',
    GhgScopes: 'ghg-scopes',
    AdverseNews: 'adverse-news',
    EutaxonomyDoesNoSignificantHarm: 'eutaxonomy-does-no-significant-harm',
    IllegalLoggingGoods: 'illegal-logging-goods',
    DualUseServices: 'dual-use-services'
} as const;

export type KosmosClobDataType = typeof KosmosClobDataType[keyof typeof KosmosClobDataType];


/**
 * 
 * @export
 * @interface KosmosCompanyMetadataDto
 */
export interface KosmosCompanyMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof KosmosCompanyMetadataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof KosmosCompanyMetadataDto
     */
    'companyAddress'?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof KosmosCompanyMetadataDto
     */
    'companyRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KosmosCompanyMetadataDto
     */
    'companyRegistrationNumberDescriptor'?: string | null;
}
/**
 * 
 * @export
 * @interface KosmosReportDto
 */
export interface KosmosReportDto {
    /**
     * 
     * @type {CompanyQuestionnaireDetailDto}
     * @memberof KosmosReportDto
     */
    'companyQuestionnaireAnswers'?: CompanyQuestionnaireDetailDto;
    /**
     * 
     * @type {CompanyDetailedDto}
     * @memberof KosmosReportDto
     */
    'atlasReport'?: CompanyDetailedDto;
    /**
     * 
     * @type {KosmosReportMetadataDto}
     * @memberof KosmosReportDto
     */
    'reportMetadata'?: KosmosReportMetadataDto;
    /**
     * 
     * @type {KosmosCompanyMetadataDto}
     * @memberof KosmosReportDto
     */
    'companyMetadata'?: KosmosCompanyMetadataDto;
    /**
     * 
     * @type {string}
     * @memberof KosmosReportDto
     */
    'reportNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportDto
     */
    'kosmosScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportDto
     */
    'kosmosEsgEnvironmentScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportDto
     */
    'kosmosEsgSocialScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportDto
     */
    'kosmosEsgGovernanceScore'?: number;
    /**
     * 
     * @type {Array<SdgScoreClobDto>}
     * @memberof KosmosReportDto
     */
    'sdgReport'?: Array<SdgScoreClobDto> | null;
    /**
     * 
     * @type {Array<SdgScoreClobDto>}
     * @memberof KosmosReportDto
     */
    'appendix'?: Array<SdgScoreClobDto> | null;
    /**
     * 
     * @type {Array<DualUseGoodsClobDto>}
     * @memberof KosmosReportDto
     */
    'dualUseGoodsReport'?: Array<DualUseGoodsClobDto> | null;
    /**
     * 
     * @type {Array<IllegalLoggingGoodsClobDto>}
     * @memberof KosmosReportDto
     */
    'illegalLoggingReport'?: Array<IllegalLoggingGoodsClobDto> | null;
    /**
     * 
     * @type {Array<DualUseServicesClobDto>}
     * @memberof KosmosReportDto
     */
    'dualUseServicesReport'?: Array<DualUseServicesClobDto> | null;
    /**
     * 
     * @type {Array<EuTaxonomyDoNoSignificantHarmClobDto>}
     * @memberof KosmosReportDto
     */
    'doesNoSignificantHarmReport'?: Array<EuTaxonomyDoNoSignificantHarmClobDto> | null;
    /**
     * 
     * @type {Array<EuTaxonomyOverallClobDto>}
     * @memberof KosmosReportDto
     */
    'euTaxonomyReport'?: Array<EuTaxonomyOverallClobDto> | null;
    /**
     * 
     * @type {Array<SustainableFinanceDisclosureRegulationClobDto>}
     * @memberof KosmosReportDto
     */
    'sustainableFinanceDisclosureRegulationReport'?: Array<SustainableFinanceDisclosureRegulationClobDto> | null;
    /**
     * 
     * @type {KosmosReportDtoGovernanceReport}
     * @memberof KosmosReportDto
     */
    'governanceReport'?: KosmosReportDtoGovernanceReport | null;
    /**
     * 
     * @type {Array<CapexOpexClobDto>}
     * @memberof KosmosReportDto
     */
    'capexOpexReport'?: Array<CapexOpexClobDto> | null;
    /**
     * 
     * @type {Array<CompanyPolicyClobDto>}
     * @memberof KosmosReportDto
     */
    'companyPolicySubmissionReport'?: Array<CompanyPolicyClobDto> | null;
    /**
     * 
     * @type {Array<GhgScopeClobDto>}
     * @memberof KosmosReportDto
     */
    'ghgScopeReport'?: Array<GhgScopeClobDto> | null;
    /**
     * 
     * @type {Array<ReportAppendix>}
     * @memberof KosmosReportDto
     */
    'ghgScopeSupplyChainAppendixReport'?: Array<ReportAppendix> | null;
    /**
     * 
     * @type {Array<NaceDetailArray>}
     * @memberof KosmosReportDto
     */
    'doesNoSignificantHarmDetailReport'?: Array<NaceDetailArray> | null;
    /**
     * 
     * @type {Array<AdverseNewsMonthCountDto>}
     * @memberof KosmosReportDto
     */
    'adverseNewsReport'?: Array<AdverseNewsMonthCountDto> | null;
}
/**
 * 
 * @export
 * @interface KosmosReportDtoGovernanceReport
 */
export interface KosmosReportDtoGovernanceReport {
    /**
     * 
     * @type {Array<GovernanceComplianceClobDto>}
     * @memberof KosmosReportDtoGovernanceReport
     */
    'NegativeGovernance'?: Array<GovernanceComplianceClobDto>;
    /**
     * 
     * @type {Array<GovernanceComplianceClobDto>}
     * @memberof KosmosReportDtoGovernanceReport
     */
    'PositiveGovernance'?: Array<GovernanceComplianceClobDto>;
}
/**
 * 
 * @export
 * @interface KosmosReportMetadataDto
 */
export interface KosmosReportMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof KosmosReportMetadataDto
     */
    'reportDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof KosmosReportMetadataDto
     */
    'reportCompanyId'?: string;
    /**
     * 
     * @type {KosmosReportType}
     * @memberof KosmosReportMetadataDto
     */
    'kosmosReportType'?: KosmosReportType;
    /**
     * 
     * @type {boolean}
     * @memberof KosmosReportMetadataDto
     */
    'isSmartGovVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof KosmosReportMetadataDto
     */
    'smartGovLinkedCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KosmosReportMetadataDto
     */
    'reportNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportMetadataDto
     */
    'kosmosEsgScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportMetadataDto
     */
    'kosmosEsgEnvironmentScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportMetadataDto
     */
    'kosmosEsgSocialScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportMetadataDto
     */
    'kosmosEsgGovernanceScore'?: number;
    /**
     * 
     * @type {Array<ReportHistoryDto>}
     * @memberof KosmosReportMetadataDto
     */
    'reportHistory'?: Array<ReportHistoryDto> | null;
}


/**
 * 
 * @export
 * @interface KosmosReportSnapshotDto
 */
export interface KosmosReportSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof KosmosReportSnapshotDto
     */
    'companyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof KosmosReportSnapshotDto
     */
    'organisationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof KosmosReportSnapshotDto
     */
    'companyReportDataId'?: string;
    /**
     * 
     * @type {string}
     * @memberof KosmosReportSnapshotDto
     */
    'created'?: string;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportSnapshotDto
     */
    'overallScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportSnapshotDto
     */
    'environmentalScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportSnapshotDto
     */
    'socialScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KosmosReportSnapshotDto
     */
    'governanceScore'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const KosmosReportType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type KosmosReportType = typeof KosmosReportType[keyof typeof KosmosReportType];


/**
 * 
 * @export
 * @interface LinkCompanyDto
 */
export interface LinkCompanyDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkCompanyDto
     */
    'companyIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LinkCompanyDto
     */
    'companyListCompanyId': string;
}
/**
 * 
 * @export
 * @interface LocaleDto
 */
export interface LocaleDto {
    /**
     * 
     * @type {string}
     * @memberof LocaleDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof LocaleDto
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface MarkNotificationRequestDto
 */
export interface MarkNotificationRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof MarkNotificationRequestDto
     */
    'markIsRead': boolean;
    /**
     * 
     * @type {string}
     * @memberof MarkNotificationRequestDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface NaceCodeClobDto
 */
export interface NaceCodeClobDto {
    /**
     * 
     * @type {string}
     * @memberof NaceCodeClobDto
     */
    'activityTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NaceCodeClobDto
     */
    'naceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NaceCodeClobDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NaceCodeClobDto
     */
    'reason'?: string | null;
    /**
     * 
     * @type {Affinity}
     * @memberof NaceCodeClobDto
     */
    'affinity'?: Affinity;
}


/**
 * 
 * @export
 * @interface NaceDetailArray
 */
export interface NaceDetailArray {
    /**
     * 
     * @type {Affinity}
     * @memberof NaceDetailArray
     */
    'overallAffinity'?: Affinity;
    /**
     * 
     * @type {boolean}
     * @memberof NaceDetailArray
     */
    'isSubstantialContribution'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NaceDetailArray
     */
    'naceActivityTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NaceDetailArray
     */
    'naceActivityId'?: string | null;
    /**
     * 
     * @type {Array<StringAffinityListKeyValuePair>}
     * @memberof NaceDetailArray
     */
    'affinities'?: Array<StringAffinityListKeyValuePair> | null;
    /**
     * 
     * @type {string}
     * @memberof NaceDetailArray
     */
    'affinityDescriptor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NaceDetailArray
     */
    'affinityDescriptorLink'?: string | null;
}


/**
 * 
 * @export
 * @interface NotificationGroupDto
 */
export interface NotificationGroupDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationGroupDto
     */
    'scoringState': string;
    /**
     * 
     * @type {Array<ScoringInformationDto>}
     * @memberof NotificationGroupDto
     */
    'information'?: Array<ScoringInformationDto> | null;
}
/**
 * 
 * @export
 * @interface NotificationSummaryDto
 */
export interface NotificationSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationSummaryDto
     */
    'companyId': string;
    /**
     * 
     * @type {Array<NotificationGroupDto>}
     * @memberof NotificationSummaryDto
     */
    'notificationGroups'?: Array<NotificationGroupDto> | null;
}
/**
 * 
 * @export
 * @interface OptionDto
 */
export interface OptionDto {
    /**
     * Option alias
     * @type {string}
     * @memberof OptionDto
     */
    'alias'?: string;
    /**
     * Option label
     * @type {string}
     * @memberof OptionDto
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface OrganisationAssignmentDto
 */
export interface OrganisationAssignmentDto {
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationAssignmentDto
     */
    'isAccepted': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'organisationId'?: string;
    /**
     * 
     * @type {OrganisationDto}
     * @memberof OrganisationAssignmentDto
     */
    'organisation'?: OrganisationDto;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'assignerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'assigneeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'kosmosCompanyName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganisationAssignmentDto
     */
    'kosmosCompanyScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'kosmosCompanyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'manualCompanyId'?: string | null;
    /**
     * 
     * @type {CompanyDetailedDto}
     * @memberof OrganisationAssignmentDto
     */
    'manualCompany'?: CompanyDetailedDto;
    /**
     * 
     * @type {CompanyDetailedDto}
     * @memberof OrganisationAssignmentDto
     */
    'kosmosCompanySnapshot'?: CompanyDetailedDto;
    /**
     * 
     * @type {CompanyDetailedDto}
     * @memberof OrganisationAssignmentDto
     */
    'sgCompanySnapshot'?: CompanyDetailedDto;
    /**
     * 
     * @type {UserDto}
     * @memberof OrganisationAssignmentDto
     */
    'assigner'?: UserDto;
    /**
     * 
     * @type {UserDto}
     * @memberof OrganisationAssignmentDto
     */
    'assignee'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationAssignmentDto
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface OrganisationAssignmentDtoQueryResultDto
 */
export interface OrganisationAssignmentDtoQueryResultDto {
    /**
     * 
     * @type {Array<OrganisationAssignmentDto>}
     * @memberof OrganisationAssignmentDtoQueryResultDto
     */
    'items'?: Array<OrganisationAssignmentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OrganisationAssignmentDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationAssignmentDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationAssignmentDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface OrganisationDto
 */
export interface OrganisationDto {
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationDto
     */
    'isRestrictedByCredits'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationDto
     * @deprecated
     */
    'hasUnlimitedCredits'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganisationDto
     */
    'remainingCredits'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationDto
     */
    'thresholdCredits'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationDto
     */
    'usersCount': number;
    /**
     * 
     * @type {OrganisationTypeDto}
     * @memberof OrganisationDto
     */
    'organisationType': OrganisationTypeDto;
    /**
     * 
     * @type {OrganisationStatusDto}
     * @memberof OrganisationDto
     */
    'status': OrganisationStatusDto;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationDto
     */
    'isEvaluating': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'updated'?: string;
}


/**
 * 
 * @export
 * @interface OrganisationDtoQueryResultDto
 */
export interface OrganisationDtoQueryResultDto {
    /**
     * 
     * @type {Array<OrganisationDto>}
     * @memberof OrganisationDtoQueryResultDto
     */
    'items'?: Array<OrganisationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OrganisationDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface OrganisationScoredCompaniesDto
 */
export interface OrganisationScoredCompaniesDto {
    /**
     * 
     * @type {string}
     * @memberof OrganisationScoredCompaniesDto
     */
    'organisationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationScoredCompaniesDto
     */
    'organisationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationScoredCompaniesDto
     */
    'companyId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationScoredCompaniesDto
     */
    'companyPlatformDiscriminator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationScoredCompaniesDto
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationScoredCompaniesDto
     */
    'companyCountry'?: string | null;
    /**
     * 
     * @type {Array<RegistrationNumberDto>}
     * @memberof OrganisationScoredCompaniesDto
     */
    'registrationNumbers'?: Array<RegistrationNumberDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OrganisationScoredCompaniesDto
     */
    'score'?: number;
    /**
     * 
     * @type {CompanyScoringState}
     * @memberof OrganisationScoredCompaniesDto
     */
    'scoringState'?: CompanyScoringState;
    /**
     * 
     * @type {string}
     * @memberof OrganisationScoredCompaniesDto
     */
    'scoredAt'?: string;
}


/**
 * 
 * @export
 * @interface OrganisationScoredCompaniesDtoQueryResultDto
 */
export interface OrganisationScoredCompaniesDtoQueryResultDto {
    /**
     * 
     * @type {Array<OrganisationScoredCompaniesDto>}
     * @memberof OrganisationScoredCompaniesDtoQueryResultDto
     */
    'items'?: Array<OrganisationScoredCompaniesDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OrganisationScoredCompaniesDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationScoredCompaniesDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationScoredCompaniesDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * Organisation status
 * @export
 * @enum {string}
 */

export const OrganisationStatusDto = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;

export type OrganisationStatusDto = typeof OrganisationStatusDto[keyof typeof OrganisationStatusDto];


/**
 * Organisation type
 * @export
 * @enum {string}
 */

export const OrganisationTypeDto = {
    TfpOrganisation: 'TFP Organisation'
} as const;

export type OrganisationTypeDto = typeof OrganisationTypeDto[keyof typeof OrganisationTypeDto];


/**
 * Kosmos report branding category
 * @export
 * @enum {string}
 */

export const PdfStyleDto = {
    CoriolisEsg: 'CoriolisEsg',
    EvoEsg: 'EvoEsg'
} as const;

export type PdfStyleDto = typeof PdfStyleDto[keyof typeof PdfStyleDto];


/**
 * 
 * @export
 * @interface QueryAndCountDto
 */
export interface QueryAndCountDto {
    /**
     * 
     * @type {number}
     * @memberof QueryAndCountDto
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryAndCountDto
     */
    'fullTextSearch'?: string | null;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof QueryAndCountDto
     */
    'filters'?: Array<FilterItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof QueryAndCountDto
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueryAndCountDto
     */
    'isDesc'?: boolean;
}
/**
 * 
 * @export
 * @interface QueryAndSortDto
 */
export interface QueryAndSortDto {
    /**
     * 
     * @type {string}
     * @memberof QueryAndSortDto
     */
    'fullTextSearch'?: string | null;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof QueryAndSortDto
     */
    'filters'?: Array<FilterItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof QueryAndSortDto
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueryAndSortDto
     */
    'isDesc'?: boolean;
}
/**
 * A true/false question (checkbox)
 * @export
 * @interface QuestionBoolDto
 */
export interface QuestionBoolDto extends QuestionDto {
    /**
     * 
     * @type {QuestionBoolFormatHint}
     * @memberof QuestionBoolDto
     */
    'format'?: QuestionBoolFormatHint;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionBoolFormatHint = {
    Select: 'Select',
    Checkbox: 'Checkbox'
} as const;

export type QuestionBoolFormatHint = typeof QuestionBoolFormatHint[keyof typeof QuestionBoolFormatHint];


/**
 * A bool question condition
 * @export
 * @interface QuestionConditionBoolDto
 */
export interface QuestionConditionBoolDto extends QuestionConditionDto {
    /**
     * Expected value
     * @type {boolean}
     * @memberof QuestionConditionBoolDto
     */
    'value'?: boolean;
}
/**
 * Question condition (abstract)
 * @export
 * @interface QuestionConditionDto
 */
export interface QuestionConditionDto {
    /**
     * Type discriminator (distinguishes between polymorphic types)
     * @type {string}
     * @memberof QuestionConditionDto
     */
    'type': string;
    /**
     * Alias of the condition\'s target question
     * @type {string}
     * @memberof QuestionConditionDto
     */
    'conditionQuestionAlias'?: string | null;
}
/**
 * A multiple-choice question condition
 * @export
 * @interface QuestionConditionMultipleChoiceDto
 */
export interface QuestionConditionMultipleChoiceDto extends QuestionConditionDto {
    /**
     * Expected option alias
     * @type {string}
     * @memberof QuestionConditionMultipleChoiceDto
     */
    'optionAlias'?: string | null;
}
/**
 * A number question condition (e.g. value greater than 3)
 * @export
 * @interface QuestionConditionNumberDto
 */
export interface QuestionConditionNumberDto extends QuestionConditionDto {
    /**
     * Value used in testing with condition operator
     * @type {number}
     * @memberof QuestionConditionNumberDto
     */
    'value'?: number;
    /**
     * 
     * @type {QuestionConditionNumberOperator}
     * @memberof QuestionConditionNumberDto
     */
    'operator'?: QuestionConditionNumberOperator;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionConditionNumberOperator = {
    Equal: 'Equal',
    NotEqual: 'NotEqual',
    GreaterThan: 'GreaterThan',
    LessThan: 'LessThan'
} as const;

export type QuestionConditionNumberOperator = typeof QuestionConditionNumberOperator[keyof typeof QuestionConditionNumberOperator];


/**
 * A date question
 * @export
 * @interface QuestionDateDto
 */
export interface QuestionDateDto extends QuestionDto {
    /**
     * Earliest allowed date (hard requirement)
     * @type {string}
     * @memberof QuestionDateDto
     */
    'dateMin'?: string | null;
    /**
     * Latest allowed date (hard requirement)
     * @type {string}
     * @memberof QuestionDateDto
     */
    'dateMax'?: string | null;
}
/**
 * Question (abstract)
 * @export
 * @interface QuestionDto
 */
export interface QuestionDto {
    /**
     * Type discriminator (distinguishes between polymorphic types)
     * @type {string}
     * @memberof QuestionDto
     */
    'type': string;
    /**
     * Formatted question number with sub-numbering for dependent questions (e.g. \"2\", \"3.4\")
     * @type {string}
     * @memberof QuestionDto
     */
    'number'?: string;
    /**
     * Question identifier
     * @type {string}
     * @memberof QuestionDto
     */
    'alias'?: string;
    /**
     * Question text shown to the user
     * @type {string}
     * @memberof QuestionDto
     */
    'label'?: string;
    /**
     * Additional description text for the question, may contain simple formatting as Markdown (e.g. lists) (optional)
     * @type {string}
     * @memberof QuestionDto
     */
    'description'?: string | null;
    /**
     * Additional HTML description for the question
     * @type {string}
     * @memberof QuestionDto
     */
    'htmlDescription'?: string | null;
    /**
     * Placeholder text to show in some UI components (optional)
     * @type {string}
     * @memberof QuestionDto
     */
    'placeholder'?: string | null;
    /**
     * Conditions that must be satisfied for the question to be shown to the user
     * @type {Array<QuestionDtoConditionsInner>}
     * @memberof QuestionDto
     */
    'conditions': Array<QuestionDtoConditionsInner>;
    /**
     * Denotes whether an answer is required for the section to be considered completed (soft requirement)
     * @type {boolean}
     * @memberof QuestionDto
     */
    'required'?: boolean;
    /**
     * Denotes question group, if any
     * @type {string}
     * @memberof QuestionDto
     */
    'questionGroupAlias'?: string;
    /**
     * Denotes that the question is currently read-only - for example, once a company registration number is accepted it is read-only
     * @type {boolean}
     * @memberof QuestionDto
     */
    'readOnly'?: boolean;
    /**
     * List of question aliases, the responses of which should be passed when checking validation
     * @type {Array<string>}
     * @memberof QuestionDto
     */
    'validationContextQuestionAliases': Array<string>;
}
/**
 * @type QuestionDtoConditionsInner
 * Question condition (abstract)
 * @export
 */
export type QuestionDtoConditionsInner = QuestionConditionBoolDto | QuestionConditionDto | QuestionConditionMultipleChoiceDto | QuestionConditionNumberDto;

/**
 * A file-list question
 * @export
 * @interface QuestionFileListDto
 */
export interface QuestionFileListDto extends QuestionDto {
    /**
     * Minimum files (soft requirement)
     * @type {number}
     * @memberof QuestionFileListDto
     */
    'filesMin'?: number;
    /**
     * Maximum files (hard requirement)
     * @type {number}
     * @memberof QuestionFileListDto
     */
    'filesMax'?: number;
    /**
     * Maximum size per file in KB (1-25600)
     * @type {number}
     * @memberof QuestionFileListDto
     */
    'fileMaxSize'?: number;
    /**
     * File extensions accepted (hard requirement)
     * @type {Array<string>}
     * @memberof QuestionFileListDto
     */
    'extensions'?: Array<string>;
}
/**
 * Describes question grouping, particularly extra information such as label and description text. Question groups have no effect on question submission and are intended as UI cues.
 * @export
 * @interface QuestionGroupDto
 */
export interface QuestionGroupDto {
    /**
     * Group identifier - group members will declare their group using this alias
     * @type {string}
     * @memberof QuestionGroupDto
     */
    'alias': string;
    /**
     * Label shown with the group
     * @type {string}
     * @memberof QuestionGroupDto
     */
    'label'?: string | null;
    /**
     * Descriptive shown with the group
     * @type {string}
     * @memberof QuestionGroupDto
     */
    'description'?: string | null;
    /**
     * Is group collapsible?
     * @type {boolean}
     * @memberof QuestionGroupDto
     */
    'isCollapse'?: boolean;
}
/**
 * Question (abstract)
 * @export
 * @interface QuestionMultipleChoiceDto
 */
export interface QuestionMultipleChoiceDto extends QuestionDto {
    /**
     * List of options
     * @type {Array<OptionDto>}
     * @memberof QuestionMultipleChoiceDto
     */
    'options': Array<OptionDto>;
    /**
     * Option set alias (if present, options should be auto-completed in the UI using the appropriate endpoint)
     * @type {string}
     * @memberof QuestionMultipleChoiceDto
     */
    'optionSetAlias': string;
    /**
     * Denotes whether user should be allowed to choose multiple or single options (e.g. checkbox list vs radio) (hard requirement)
     * @type {boolean}
     * @memberof QuestionMultipleChoiceDto
     */
    'allowMultiple': boolean;
    /**
     * 
     * @type {QuestionMultipleChoiceFormatHint}
     * @memberof QuestionMultipleChoiceDto
     */
    'format': QuestionMultipleChoiceFormatHint;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionMultipleChoiceFormatHint = {
    CheckboxList: 'CheckboxList',
    Select: 'Select',
    RadioList: 'RadioList',
    HsCode: 'HsCode',
    EsgTaxonomy: 'EsgTaxonomy',
    AutoComplete: 'AutoComplete',
    ClimateMitigationActivity: 'ClimateMitigationActivity',
    ClimateAdaptationActivity: 'ClimateAdaptationActivity'
} as const;

export type QuestionMultipleChoiceFormatHint = typeof QuestionMultipleChoiceFormatHint[keyof typeof QuestionMultipleChoiceFormatHint];


/**
 * Question (abstract)
 * @export
 * @interface QuestionNumberDto
 */
export interface QuestionNumberDto extends QuestionDto {
    /**
     * Minimum value (hard requirement)
     * @type {number}
     * @memberof QuestionNumberDto
     */
    'max'?: number;
    /**
     * Maximum value (hard requirement)
     * @type {number}
     * @memberof QuestionNumberDto
     */
    'min'?: number;
    /**
     * 
     * @type {QuestionNumberFormatHint}
     * @memberof QuestionNumberDto
     */
    'format'?: QuestionNumberFormatHint;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionNumberFormatHint = {
    Number: 'Number',
    Range: 'Range',
    Currency: 'Currency',
    Percentage: 'Percentage'
} as const;

export type QuestionNumberFormatHint = typeof QuestionNumberFormatHint[keyof typeof QuestionNumberFormatHint];


/**
 * Bool question response
 * @export
 * @interface QuestionResponseBoolDto
 */
export interface QuestionResponseBoolDto extends QuestionResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof QuestionResponseBoolDto
     */
    'value': boolean;
}
/**
 * Question response (abstract)
 * @export
 * @interface QuestionResponseDateDto
 */
export interface QuestionResponseDateDto extends QuestionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof QuestionResponseDateDto
     */
    'value': string;
}
/**
 * Question response (abstract)
 * @export
 * @interface QuestionResponseDto
 */
export interface QuestionResponseDto {
    /**
     * Type discriminator (distinguishes between polymorphic types)
     * @type {string}
     * @memberof QuestionResponseDto
     */
    'type': string;
    /**
     * Alias of the associated question
     * @type {string}
     * @memberof QuestionResponseDto
     */
    'questionAlias': string;
}
/**
 * File-list question response
 * @export
 * @interface QuestionResponseFileDto
 */
export interface QuestionResponseFileDto extends QuestionResponseDto {
    /**
     * File response ID (used for removing files)
     * @type {string}
     * @memberof QuestionResponseFileDto
     */
    'id'?: string;
    /**
     * File name of uploaded document
     * @type {string}
     * @memberof QuestionResponseFileDto
     */
    'fileName': string;
    /**
     * File data as a base 64 encoded string
     * @type {string}
     * @memberof QuestionResponseFileDto
     */
    'data': string;
    /**
     * File extension (e.g. \"pdf\", \"docm\")
     * @type {string}
     * @memberof QuestionResponseFileDto
     */
    'extension': string;
    /**
     * File content md5
     * @type {string}
     * @memberof QuestionResponseFileDto
     */
    'contentMd5'?: string | null;
}
/**
 * Multiple-choice question response
 * @export
 * @interface QuestionResponseMultipleChoiceDto
 */
export interface QuestionResponseMultipleChoiceDto extends QuestionResponseDto {
    /**
     * Option aliases for chosen option(s)
     * @type {Array<string>}
     * @memberof QuestionResponseMultipleChoiceDto
     */
    'optionAliases': Array<string>;
    /**
     * Option aliases with label for chosen option(s)
     * @type {Array<OptionDto>}
     * @memberof QuestionResponseMultipleChoiceDto
     */
    'selectedOptions': Array<OptionDto>;
    /**
     * If applicable, a free-text answer provided by the user
     * @type {string}
     * @memberof QuestionResponseMultipleChoiceDto
     */
    'otherValue'?: string | null;
}
/**
 * Number question response
 * @export
 * @interface QuestionResponseNumberDto
 */
export interface QuestionResponseNumberDto extends QuestionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof QuestionResponseNumberDto
     */
    'value': number;
}
/**
 * Tabular choice question response
 * @export
 * @interface QuestionResponseTabularChoiceDto
 */
export interface QuestionResponseTabularChoiceDto extends QuestionResponseDto {
    /**
     * Options selected
     * @type {Array<SelectedTabularOption>}
     * @memberof QuestionResponseTabularChoiceDto
     */
    'selectedOptions': Array<SelectedTabularOption>;
}
/**
 * Question response (abstract)
 * @export
 * @interface QuestionResponseTextDto
 */
export interface QuestionResponseTextDto extends QuestionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof QuestionResponseTextDto
     */
    'value': string;
}
/**
 * Question response (abstract)
 * @export
 * @interface QuestionResponseTextListDto
 */
export interface QuestionResponseTextListDto extends QuestionResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionResponseTextListDto
     */
    'values': Array<string>;
}
/**
 * A list of nested sections (for example, a list of client contract details)
 * @export
 * @interface QuestionSubSectionListDto
 */
export interface QuestionSubSectionListDto extends QuestionDto {
    /**
     * 
     * @type {number}
     * @memberof QuestionSubSectionListDto
     */
    'itemsMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestionSubSectionListDto
     */
    'itemsMax'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionSubSectionListDto
     */
    'subSectionAlias'?: string | null;
    /**
     * 
     * @type {QuestionSubSectionListFormatHint}
     * @memberof QuestionSubSectionListDto
     */
    'format'?: QuestionSubSectionListFormatHint;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionSubSectionListFormatHint = {
    Default: 'Default',
    DirectorOrShareholder: 'DirectorOrShareholder'
} as const;

export type QuestionSubSectionListFormatHint = typeof QuestionSubSectionListFormatHint[keyof typeof QuestionSubSectionListFormatHint];


/**
 * Question (abstract)
 * @export
 * @interface QuestionTabularChoiceDto
 */
export interface QuestionTabularChoiceDto extends QuestionDto {
    /**
     * List of column options
     * @type {Array<OptionDto>}
     * @memberof QuestionTabularChoiceDto
     */
    'columnOptions': Array<OptionDto>;
    /**
     * Option set alias (if present, options should be auto-completed in the UI using the appropriate endpoint)
     * @type {string}
     * @memberof QuestionTabularChoiceDto
     */
    'columnOptionSetAlias': string;
    /**
     * Number of columns in the table
     * @type {number}
     * @memberof QuestionTabularChoiceDto
     */
    'columnOptionsCount': number;
    /**
     * List of row options
     * @type {Array<OptionDto>}
     * @memberof QuestionTabularChoiceDto
     */
    'rowOptions': Array<OptionDto>;
    /**
     * Option set alias (if present, options should be auto-completed in the UI using the appropriate endpoint)
     * @type {string}
     * @memberof QuestionTabularChoiceDto
     */
    'rowOptionSetAlias': string;
    /**
     * Number of rows in the table
     * @type {number}
     * @memberof QuestionTabularChoiceDto
     */
    'rowOptionsCount': number;
    /**
     * Denotes whether user should be allowed to choose multiple or single options (e.g. checkbox list vs radio) (hard requirement)
     * @type {boolean}
     * @memberof QuestionTabularChoiceDto
     */
    'allowMultiple': boolean;
    /**
     * 
     * @type {QuestionTabularChoiceFormatHint}
     * @memberof QuestionTabularChoiceDto
     */
    'format': QuestionTabularChoiceFormatHint;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionTabularChoiceFormatHint = {
    CheckboxList: 'CheckboxList',
    RadioList: 'RadioList'
} as const;

export type QuestionTabularChoiceFormatHint = typeof QuestionTabularChoiceFormatHint[keyof typeof QuestionTabularChoiceFormatHint];


/**
 * A free-text question
 * @export
 * @interface QuestionTextDto
 */
export interface QuestionTextDto extends QuestionDto {
    /**
     * Minimum character count (soft requirement)
     * @type {number}
     * @memberof QuestionTextDto
     */
    'characterMin'?: number | null;
    /**
     * Maximum character count (hard requirement)
     * @type {number}
     * @memberof QuestionTextDto
     */
    'characterMax'?: number | null;
    /**
     * 
     * @type {QuestionTextFormatHint}
     * @memberof QuestionTextDto
     */
    'format'?: QuestionTextFormatHint;
    /**
     * Input regex (soft requirement)
     * @type {string}
     * @memberof QuestionTextDto
     */
    'regex'?: string | null;
}
/**
 * Formatting and validation hint text questions
 * @export
 * @enum {string}
 */

export const QuestionTextFormatHint = {
    Text: 'Text',
    Email: 'Email',
    Phone: 'Phone',
    Url: 'Url',
    HsCode: 'HsCode',
    CompanyRegistrationNumber: 'CompanyRegistrationNumber',
    CompanyName: 'CompanyName'
} as const;

export type QuestionTextFormatHint = typeof QuestionTextFormatHint[keyof typeof QuestionTextFormatHint];


/**
 * A question answered with a list of text responses
 * @export
 * @interface QuestionTextListDto
 */
export interface QuestionTextListDto extends QuestionDto {
    /**
     * Minimum items in the list (soft requirement)
     * @type {number}
     * @memberof QuestionTextListDto
     */
    'itemsMin'?: number | null;
    /**
     * Maximum items in the list (hard requirement)
     * @type {number}
     * @memberof QuestionTextListDto
     */
    'itemsMax'?: number | null;
    /**
     * Maximum character count per item (hard requirement)
     * @type {number}
     * @memberof QuestionTextListDto
     */
    'characterMax'?: number;
}
/**
 * 
 * @export
 * @interface RegistrationNumberDto
 */
export interface RegistrationNumberDto {
    /**
     * 
     * @type {string}
     * @memberof RegistrationNumberDto
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegistrationNumberDto
     */
    'typeDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportAppendix
 */
export interface ReportAppendix {
    /**
     * 
     * @type {number}
     * @memberof ReportAppendix
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportAppendix
     */
    'title'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ReportAppendix
     */
    'details'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {Affinity}
     * @memberof ReportAppendix
     */
    'affinity'?: Affinity;
}


/**
 * 
 * @export
 * @interface ReportHistoryDto
 */
export interface ReportHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof ReportHistoryDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportHistoryDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportHistoryDto
     */
    'pdfDocumentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportHistoryDto
     */
    'htmlDocumentId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'overallScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'environmentalScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'socialScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'governanceScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'atlasQuestionnaireOverallScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'atlasQuestionnaireEnvironmentalScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'atlasQuestionnaireSocialScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportHistoryDto
     */
    'atlasQuestionnaireGovernanceScore'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportHistoryDto
     */
    'isCurrentReport'?: boolean;
}
/**
 * Kosmos report Type category
 * @export
 * @enum {string}
 */

export const ReportTypeDto = {
    Summary: 'Summary',
    Detailed: 'Detailed'
} as const;

export type ReportTypeDto = typeof ReportTypeDto[keyof typeof ReportTypeDto];


/**
 * 
 * @export
 * @interface ScoringInformationDto
 */
export interface ScoringInformationDto {
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {ScoringInformationType}
     * @memberof ScoringInformationDto
     */
    'type'?: ScoringInformationType;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'sectionAlias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'questionAlias'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ScoringInformationDto
     */
    'actionable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'resourceUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'scoreAlias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'scoreName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'scoringRuleAlias'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ScoringInformationDto
     */
    'seen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScoringInformationDto
     */
    'blocking'?: boolean;
    /**
     * 
     * @type {InformationPlatform}
     * @memberof ScoringInformationDto
     */
    'platform'?: InformationPlatform;
    /**
     * 
     * @type {string}
     * @memberof ScoringInformationDto
     */
    'kosmosClobData'?: string | null;
    /**
     * 
     * @type {KosmosClobDataType}
     * @memberof ScoringInformationDto
     */
    'kosmosType'?: KosmosClobDataType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ScoringInformationType = {
    Info: 'Info',
    Success: 'Success',
    Warning: 'Warning',
    Danger: 'Danger'
} as const;

export type ScoringInformationType = typeof ScoringInformationType[keyof typeof ScoringInformationType];


/**
 * 
 * @export
 * @interface SdgScoreClobDto
 */
export interface SdgScoreClobDto {
    /**
     * 
     * @type {string}
     * @memberof SdgScoreClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SdgScoreClobDto
     */
    'sdgNumber'?: number;
    /**
     * 
     * @type {Affinity}
     * @memberof SdgScoreClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {IccDimension}
     * @memberof SdgScoreClobDto
     */
    'iccDimension'?: IccDimension;
    /**
     * 
     * @type {Array<NaceCodeClobDto>}
     * @memberof SdgScoreClobDto
     */
    'associatedNaceCodes'?: Array<NaceCodeClobDto> | null;
}


/**
 * A section is a block of questions. The onboarding questionnaire is made-up of many sections.
 * @export
 * @interface SectionDto
 */
export interface SectionDto {
    /**
     * List of questions that make up the section
     * @type {Array<SectionDtoQuestionsInner>}
     * @memberof SectionDto
     */
    'questions'?: Array<SectionDtoQuestionsInner>;
    /**
     * List of sub-sections used in the questions
     * @type {Array<SubSectionDto>}
     * @memberof SectionDto
     */
    'subSections'?: Array<SubSectionDto>;
    /**
     * 
     * @type {SectionResponseDto}
     * @memberof SectionDto
     */
    'sectionResponse'?: SectionResponseDto;
    /**
     * 
     * @type {Array<ScoringInformationDto>}
     * @memberof SectionDto
     */
    'scoringInformation'?: Array<ScoringInformationDto> | null;
    /**
     * 
     * @type {Array<QuestionGroupDto>}
     * @memberof SectionDto
     */
    'questionGroups'?: Array<QuestionGroupDto> | null;
    /**
     * Section identifier
     * @type {string}
     * @memberof SectionDto
     */
    'alias'?: string;
    /**
     * The section human-readable name
     * @type {string}
     * @memberof SectionDto
     */
    'label'?: string;
    /**
     * 
     * @type {SectionResponseState}
     * @memberof SectionDto
     */
    'sectionResponseState'?: SectionResponseState;
    /**
     * A list of sections (by alias) that must be complete before this section
     * @type {Array<string>}
     * @memberof SectionDto
     */
    'prerequisiteSections'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SectionDto
     */
    'level'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SectionDto
     */
    'labelDictionary'?: { [key: string]: string; } | null;
}


/**
 * @type SectionDtoQuestionsInner
 * Question (abstract)
 * @export
 */
export type SectionDtoQuestionsInner = QuestionBoolDto | QuestionDateDto | QuestionDto | QuestionFileListDto | QuestionMultipleChoiceDto | QuestionNumberDto | QuestionSubSectionListDto | QuestionTabularChoiceDto | QuestionTextDto | QuestionTextListDto;

/**
 * 
 * @export
 * @interface SectionResponseDto
 */
export interface SectionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SectionResponseDto
     */
    'sectionAlias': string;
    /**
     * 
     * @type {string}
     * @memberof SectionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SectionResponseDto
     */
    'dealId'?: string | null;
    /**
     * 
     * @type {SectionResponseState}
     * @memberof SectionResponseDto
     */
    'state': SectionResponseState;
    /**
     * 
     * @type {Array<CheckQuestionResponseDtoValidationContextInner>}
     * @memberof SectionResponseDto
     */
    'responses': Array<CheckQuestionResponseDtoValidationContextInner>;
    /**
     * 
     * @type {Array<SubSectionResponseDto>}
     * @memberof SectionResponseDto
     */
    'subSectionResponses': Array<SubSectionResponseDto>;
    /**
     * List of aliases for questions that are currently unsatisfied
     * @type {Array<string>}
     * @memberof SectionResponseDto
     */
    'unsatisfiedQuestions': Array<string>;
}


/**
 * Represents section state of completion. Unanswered sections are \"NotStarted\", once all required questions are satisfied the section is \"Completed\". Sections may move between \"Partial\" and \"Complete\".
 * @export
 * @enum {string}
 */

export const SectionResponseState = {
    Unknown: 'Unknown',
    NotStarted: 'NotStarted',
    Partial: 'Partial',
    Completed: 'Completed'
} as const;

export type SectionResponseState = typeof SectionResponseState[keyof typeof SectionResponseState];


/**
 * 
 * @export
 * @interface SectionResponseUpdatedDto
 */
export interface SectionResponseUpdatedDto {
    /**
     * 
     * @type {EntityScoreSummaryDto}
     * @memberof SectionResponseUpdatedDto
     */
    'score': EntityScoreSummaryDto;
    /**
     * 
     * @type {Array<ScoringInformationDto>}
     * @memberof SectionResponseUpdatedDto
     */
    'scoringUpdates': Array<ScoringInformationDto>;
    /**
     * 
     * @type {Array<ScoringInformationDto>}
     * @memberof SectionResponseUpdatedDto
     */
    'scoringInformation': Array<ScoringInformationDto>;
    /**
     * 
     * @type {string}
     * @memberof SectionResponseUpdatedDto
     */
    'sectionAlias': string;
    /**
     * 
     * @type {string}
     * @memberof SectionResponseUpdatedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SectionResponseUpdatedDto
     */
    'dealId'?: string | null;
    /**
     * 
     * @type {SectionResponseState}
     * @memberof SectionResponseUpdatedDto
     */
    'state': SectionResponseState;
    /**
     * 
     * @type {Array<CheckQuestionResponseDtoValidationContextInner>}
     * @memberof SectionResponseUpdatedDto
     */
    'responses': Array<CheckQuestionResponseDtoValidationContextInner>;
    /**
     * 
     * @type {Array<SubSectionResponseDto>}
     * @memberof SectionResponseUpdatedDto
     */
    'subSectionResponses': Array<SubSectionResponseDto>;
    /**
     * List of aliases for questions that are currently unsatisfied
     * @type {Array<string>}
     * @memberof SectionResponseUpdatedDto
     */
    'unsatisfiedQuestions': Array<string>;
}


/**
 * A section is a block of questions that make up the onboarding questionnaire. Note a section **stub** is missing the full question list
 * @export
 * @interface SectionStubDto
 */
export interface SectionStubDto {
    /**
     * Section identifier
     * @type {string}
     * @memberof SectionStubDto
     */
    'alias'?: string;
    /**
     * The section human-readable name
     * @type {string}
     * @memberof SectionStubDto
     */
    'label'?: string;
    /**
     * 
     * @type {SectionResponseState}
     * @memberof SectionStubDto
     */
    'sectionResponseState'?: SectionResponseState;
    /**
     * A list of sections (by alias) that must be complete before this section
     * @type {Array<string>}
     * @memberof SectionStubDto
     */
    'prerequisiteSections'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SectionStubDto
     */
    'level'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SectionStubDto
     */
    'labelDictionary'?: { [key: string]: string; } | null;
}


/**
 * A collection of answers for a section
 * @export
 * @interface SectionUpdateDto
 */
export interface SectionUpdateDto {
    /**
     * Section alias
     * @type {string}
     * @memberof SectionUpdateDto
     */
    'sectionAlias': string;
    /**
     * Company ID
     * @type {string}
     * @memberof SectionUpdateDto
     */
    'companyId'?: string | null;
    /**
     * Deal ID
     * @type {string}
     * @memberof SectionUpdateDto
     */
    'dealId'?: string | null;
    /**
     * List of question responses
     * @type {Array<CheckQuestionResponseDtoValidationContextInner>}
     * @memberof SectionUpdateDto
     */
    'questionResponses': Array<CheckQuestionResponseDtoValidationContextInner>;
    /**
     * List of sub-section responses
     * @type {Array<SubSectionUpdateDto>}
     * @memberof SectionUpdateDto
     */
    'subSectionResponses': Array<SubSectionUpdateDto>;
}
/**
 * 
 * @export
 * @interface SectorCodeDto
 */
export interface SectorCodeDto {
    /**
     * 
     * @type {string}
     * @memberof SectorCodeDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SectorCodeDto
     */
    'sector'?: string | null;
}
/**
 * 
 * @export
 * @interface SectorCodeWithCriteriaScoreDto
 */
export interface SectorCodeWithCriteriaScoreDto {
    /**
     * 
     * @type {string}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'activityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'activity'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'climateMitigation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'climateAdaptation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'water'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'circularEconomy'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'pollutionPrevention'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'biodiversity'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SectorCodeWithCriteriaScoreDto
     */
    'score'?: number;
}
/**
 * 
 * @export
 * @interface SelectedTabularOption
 */
export interface SelectedTabularOption {
    /**
     * Option alias for the row option
     * @type {string}
     * @memberof SelectedTabularOption
     */
    'rowOptionAlias': string;
    /**
     * 
     * @type {OptionDto}
     * @memberof SelectedTabularOption
     */
    'rowOption': OptionDto;
    /**
     * Option aliases for chosen column option(s)
     * @type {Array<string>}
     * @memberof SelectedTabularOption
     */
    'columnOptionAliases': Array<string>;
    /**
     * Option aliases with label for chosen column option(s)
     * @type {Array<OptionDto>}
     * @memberof SelectedTabularOption
     */
    'columnOptions': Array<OptionDto>;
}
/**
 * 
 * @export
 * @interface StringAffinityListKeyValuePair
 */
export interface StringAffinityListKeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof StringAffinityListKeyValuePair
     */
    'key'?: string | null;
    /**
     * 
     * @type {Array<Affinity>}
     * @memberof StringAffinityListKeyValuePair
     */
    'value'?: Array<Affinity> | null;
}
/**
 * A list of questions that make up a sub-section
 * @export
 * @interface SubSectionDto
 */
export interface SubSectionDto {
    /**
     * Sub-section identifier
     * @type {string}
     * @memberof SubSectionDto
     */
    'alias'?: string;
    /**
     * List of questions that make up the sub-section
     * @type {Array<SectionDtoQuestionsInner>}
     * @memberof SubSectionDto
     */
    'questions'?: Array<SectionDtoQuestionsInner>;
    /**
     * 
     * @type {Array<QuestionGroupDto>}
     * @memberof SubSectionDto
     */
    'questionGroups'?: Array<QuestionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface SubSectionResponseDto
 */
export interface SubSectionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SubSectionResponseDto
     */
    'id'?: string;
    /**
     * 
     * @type {SectionResponseState}
     * @memberof SubSectionResponseDto
     */
    'state'?: SectionResponseState;
    /**
     * Display name of the sub-section response (e.g. \"Contract 2\")
     * @type {string}
     * @memberof SubSectionResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubSectionResponseDto
     */
    'subSectionAlias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubSectionResponseDto
     */
    'questionAlias'?: string | null;
    /**
     * 
     * @type {Array<CheckQuestionResponseDtoValidationContextInner>}
     * @memberof SubSectionResponseDto
     */
    'responses'?: Array<CheckQuestionResponseDtoValidationContextInner> | null;
    /**
     * 
     * @type {number}
     * @memberof SubSectionResponseDto
     */
    'sortOrder'?: number;
    /**
     * List of aliases for questions that are currently unsatisfied
     * @type {Array<string>}
     * @memberof SubSectionResponseDto
     */
    'unsatisfiedQuestions'?: Array<string>;
}


/**
 * A collection of answers for a sub-section
 * @export
 * @interface SubSectionUpdateDto
 */
export interface SubSectionUpdateDto {
    /**
     * The ID of an existing sub-section response to update
     * @type {string}
     * @memberof SubSectionUpdateDto
     */
    'subSectionId'?: string;
    /**
     * The alias of the associated question
     * @type {string}
     * @memberof SubSectionUpdateDto
     */
    'questionAlias': string;
    /**
     * List of question responses
     * @type {Array<CheckQuestionResponseDtoValidationContextInner>}
     * @memberof SubSectionUpdateDto
     */
    'questionResponses': Array<CheckQuestionResponseDtoValidationContextInner>;
}
/**
 * 
 * @export
 * @interface SustainableFinanceDisclosureRegulationClobDto
 */
export interface SustainableFinanceDisclosureRegulationClobDto {
    /**
     * 
     * @type {number}
     * @memberof SustainableFinanceDisclosureRegulationClobDto
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof SustainableFinanceDisclosureRegulationClobDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SustainableFinanceDisclosureRegulationClobDto
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {Affinity}
     * @memberof SustainableFinanceDisclosureRegulationClobDto
     */
    'affinity'?: Affinity;
    /**
     * 
     * @type {string}
     * @memberof SustainableFinanceDisclosureRegulationClobDto
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @interface TempTaskFuncDto
 */
export interface TempTaskFuncDto {
    /**
     * 
     * @type {string}
     * @memberof TempTaskFuncDto
     */
    'funcName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempTaskFuncDto
     */
    'funcDesc'?: string | null;
}
/**
 * 
 * @export
 * @interface TempTaskRequestDto
 */
export interface TempTaskRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TempTaskRequestDto
     */
    'funcName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempTaskRequestDto
     */
    'funcData'?: string | null;
}
/**
 * 
 * @export
 * @interface TransactionDto
 */
export interface TransactionDto {
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'financialProduct'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'financialProductReference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'organisationId'?: string;
    /**
     * 
     * @type {OrganisationDto}
     * @memberof TransactionDto
     */
    'organisation'?: OrganisationDto;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'buyerId'?: string;
    /**
     * 
     * @type {CompanyDto}
     * @memberof TransactionDto
     */
    'buyer'?: CompanyDto;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'sellerId'?: string;
    /**
     * 
     * @type {CompanyDto}
     * @memberof TransactionDto
     */
    'seller'?: CompanyDto;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    'transactionScore'?: number;
    /**
     * 
     * @type {Array<EntityScoreDto>}
     * @memberof TransactionDto
     */
    'scores'?: Array<EntityScoreDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'lastTriggeredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    'lastScoredAt'?: string;
    /**
     * 
     * @type {CompanyScoringState}
     * @memberof TransactionDto
     */
    'scoringState'?: CompanyScoringState;
}


/**
 * 
 * @export
 * @interface TransactionDtoQueryResultDto
 */
export interface TransactionDtoQueryResultDto {
    /**
     * 
     * @type {Array<TransactionDto>}
     * @memberof TransactionDtoQueryResultDto
     */
    'items'?: Array<TransactionDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * Transaction report type category
 * @export
 * @enum {string}
 */

export const TransactionReportTypeDto = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type TransactionReportTypeDto = typeof TransactionReportTypeDto[keyof typeof TransactionReportTypeDto];


/**
 * 
 * @export
 * @interface TransactionScoringRequestDto
 */
export interface TransactionScoringRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TransactionScoringRequestDto
     */
    'financialProduct'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionScoringRequestDto
     */
    'financialProductReference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionScoringRequestDto
     */
    'buyerId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionScoringRequestDto
     */
    'sellerId': string;
    /**
     * 
     * @type {Array<TransportationScoringRequestDto>}
     * @memberof TransactionScoringRequestDto
     */
    'transportations': Array<TransportationScoringRequestDto>;
}
/**
 * 
 * @export
 * @interface TransactionScoringResponseDto
 */
export interface TransactionScoringResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TransactionScoringResponseDto
     */
    'transactionId'?: string | null;
}
/**
 * 
 * @export
 * @interface TranslationDto
 */
export interface TranslationDto {
    /**
     * 
     * @type {string}
     * @memberof TranslationDto
     */
    'stringId': string;
    /**
     * 
     * @type {string}
     * @memberof TranslationDto
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface TransportationScoringRequestDto
 */
export interface TransportationScoringRequestDto {
    /**
     * 
     * @type {ETransportationMode}
     * @memberof TransportationScoringRequestDto
     */
    'transportationMode': ETransportationMode;
    /**
     * 
     * @type {string}
     * @memberof TransportationScoringRequestDto
     */
    'originLocode': string;
    /**
     * 
     * @type {string}
     * @memberof TransportationScoringRequestDto
     */
    'destinationLocode': string;
    /**
     * 
     * @type {Array<TransportedProduct>}
     * @memberof TransportationScoringRequestDto
     */
    'products': Array<TransportedProduct>;
}


/**
 * 
 * @export
 * @interface TransportedProduct
 */
export interface TransportedProduct {
    /**
     * 
     * @type {string}
     * @memberof TransportedProduct
     */
    'hsCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransportedProduct
     */
    'weightInKg'?: number;
    /**
     * 
     * @type {string}
     * @memberof TransportedProduct
     */
    'countryOfOrigin'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateCompanyListRequestDto
 */
export interface UpdateCompanyListRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyListRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyListRequestDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateOrganisationRequestDto
 */
export interface UpdateOrganisationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationRequestDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganisationRequestDto
     */
    'hasUnlimitedCredits'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganisationRequestDto
     */
    'isEvaluating'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateUserRequestDto
 */
export interface UpdateUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    'organisationId'?: string | null;
    /**
     * 
     * @type {UserRoleDto}
     * @memberof UpdateUserRequestDto
     */
    'userRole'?: UserRoleDto;
}


/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'aadUserId': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {UserRoleDto}
     * @memberof UserDto
     */
    'userRole': UserRoleDto;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'organisationId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'accountEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'organisationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'updated'?: string;
}


/**
 * 
 * @export
 * @interface UserDtoQueryResultDto
 */
export interface UserDtoQueryResultDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof UserDtoQueryResultDto
     */
    'items'?: Array<UserDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UserDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * The Role of user in atlas/kosmos
 * @export
 * @enum {string}
 */

export const UserRoleDto = {
    Sme: 'SME',
    Tfp: 'TFP',
    Admin: 'Admin',
    ServiceTfp: 'ServiceTfp',
    OrgAdmin: 'OrgAdmin'
} as const;

export type UserRoleDto = typeof UserRoleDto[keyof typeof UserRoleDto];


/**
 * Verification status of a company
 * @export
 * @enum {string}
 */

export const VerificationStatusDto = {
    Pending: 'Pending',
    NotFound: 'NotFound',
    VerifyError: 'VerifyError',
    Verified: 'Verified',
    MultipleResults: 'MultipleResults'
} as const;

export type VerificationStatusDto = typeof VerificationStatusDto[keyof typeof VerificationStatusDto];


/**
 * 
 * @export
 * @interface WomeApplicationDto
 */
export interface WomeApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'updated'?: string;
    /**
     * 
     * @type {WomeStatusDto}
     * @memberof WomeApplicationDto
     */
    'womeStatus'?: WomeStatusDto;
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'adminNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'organisationId': string;
    /**
     * 
     * @type {OrganisationDto}
     * @memberof WomeApplicationDto
     */
    'organisation'?: OrganisationDto;
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'createByUserId'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof WomeApplicationDto
     */
    'createByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'acceptedByUserId'?: string | null;
    /**
     * 
     * @type {UserDto}
     * @memberof WomeApplicationDto
     */
    'acceptedByUser'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationDto
     */
    'womeCompanyId': string;
    /**
     * 
     * @type {CompanyScoreDto}
     * @memberof WomeApplicationDto
     */
    'womeCompany'?: CompanyScoreDto;
}


/**
 * 
 * @export
 * @interface WomeApplicationDtoQueryResultDto
 */
export interface WomeApplicationDtoQueryResultDto {
    /**
     * 
     * @type {Array<WomeApplicationDto>}
     * @memberof WomeApplicationDtoQueryResultDto
     */
    'items'?: Array<WomeApplicationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WomeApplicationDtoQueryResultDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof WomeApplicationDtoQueryResultDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WomeApplicationDtoQueryResultDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface WomeApplicationUpdateDto
 */
export interface WomeApplicationUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof WomeApplicationUpdateDto
     */
    'adminNote'?: string | null;
}
/**
 * Wome Application Status
 * @export
 * @enum {string}
 */

export const WomeStatusDto = {
    Pending: 'Pending',
    WaitingReview: 'WaitingReview',
    Rejected: 'Rejected',
    Approved: 'Approved'
} as const;

export type WomeStatusDto = typeof WomeStatusDto[keyof typeof WomeStatusDto];



/**
 * AuditLogApi - axios parameter creator
 * @export
 */
export const AuditLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve all audit logs
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (queryAndSortDto?: QueryAndSortDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuditLog/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Group audit by actionName
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogSummary: async (queryAndSortDto?: QueryAndSortDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuditLog/GetSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all audit logs for admin or tfp with pagination
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginatedAuditLogs: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuditLog/GetPaginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditLogApi - functional programming interface
 * @export
 */
export const AuditLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve all audit logs
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(queryAndSortDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Group audit by actionName
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditLogSummary(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditLogSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditLogSummary(queryAndSortDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve all audit logs for admin or tfp with pagination
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginatedAuditLogs(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginatedAuditLogs(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuditLogApi - factory interface
 * @export
 */
export const AuditLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditLogApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve all audit logs
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(queryAndSortDto?: QueryAndSortDto, options?: any): AxiosPromise<Array<AuditLogDto>> {
            return localVarFp.getAll(queryAndSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Group audit by actionName
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogSummary(queryAndSortDto?: QueryAndSortDto, options?: any): AxiosPromise<Array<AuditLogSummaryDto>> {
            return localVarFp.getAuditLogSummary(queryAndSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all audit logs for admin or tfp with pagination
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginatedAuditLogs(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<AuditLogDtoQueryResultDto> {
            return localVarFp.getPaginatedAuditLogs(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditLogApi - object-oriented interface
 * @export
 * @class AuditLogApi
 * @extends {BaseAPI}
 */
export class AuditLogApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve all audit logs
     * @param {QueryAndSortDto} [queryAndSortDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogApi
     */
    public getAll(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig) {
        return AuditLogApiFp(this.configuration).getAll(queryAndSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Group audit by actionName
     * @param {QueryAndSortDto} [queryAndSortDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogApi
     */
    public getAuditLogSummary(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig) {
        return AuditLogApiFp(this.configuration).getAuditLogSummary(queryAndSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all audit logs for admin or tfp with pagination
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogApi
     */
    public getPaginatedAuditLogs(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return AuditLogApiFp(this.configuration).getPaginatedAuditLogs(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommodityCodesApi - axios parameter creator
 * @export
 */
export const CommodityCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of commodity codes that match the given query string or codes.
         * @summary Search Commodity(HS or EBOPS) codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommodity: async (query?: string, ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CommodityCodes/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of commodity codes that match the given query string or codes.
         * @summary Search HS codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHsCode: async (query?: string, ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CommodityCodes/SearchHsCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommodityCodesApi - functional programming interface
 * @export
 */
export const CommodityCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommodityCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of commodity codes that match the given query string or codes.
         * @summary Search Commodity(HS or EBOPS) codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCommodity(query?: string, ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommodityCodeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCommodity(query, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of commodity codes that match the given query string or codes.
         * @summary Search HS codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchHsCode(query?: string, ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommodityCodeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchHsCode(query, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommodityCodesApi - factory interface
 * @export
 */
export const CommodityCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommodityCodesApiFp(configuration)
    return {
        /**
         * Returns a list of commodity codes that match the given query string or codes.
         * @summary Search Commodity(HS or EBOPS) codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommodity(query?: string, ids?: Array<string>, options?: any): AxiosPromise<Array<CommodityCodeDto>> {
            return localVarFp.searchCommodity(query, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of commodity codes that match the given query string or codes.
         * @summary Search HS codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHsCode(query?: string, ids?: Array<string>, options?: any): AxiosPromise<Array<CommodityCodeDto>> {
            return localVarFp.searchHsCode(query, ids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommodityCodesApi - object-oriented interface
 * @export
 * @class CommodityCodesApi
 * @extends {BaseAPI}
 */
export class CommodityCodesApi extends BaseAPI {
    /**
     * Returns a list of commodity codes that match the given query string or codes.
     * @summary Search Commodity(HS or EBOPS) codes by query string or list of codes
     * @param {string} [query] 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityCodesApi
     */
    public searchCommodity(query?: string, ids?: Array<string>, options?: AxiosRequestConfig) {
        return CommodityCodesApiFp(this.configuration).searchCommodity(query, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of commodity codes that match the given query string or codes.
     * @summary Search HS codes by query string or list of codes
     * @param {string} [query] 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityCodesApi
     */
    public searchHsCode(query?: string, ids?: Array<string>, options?: AxiosRequestConfig) {
        return CommodityCodesApiFp(this.configuration).searchHsCode(query, ids, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search company by registration number or company name
         * @summary Search company
         * @param {string} [query] 
         * @param {string} [countryCode3] 
         * @param {string} [externalIdentifier] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        atlasCompanySearch: async (query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Company/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (countryCode3 !== undefined) {
                localVarQueryParameter['countryCode3'] = countryCode3;
            }

            if (externalIdentifier !== undefined) {
                localVarQueryParameter['externalIdentifier'] = externalIdentifier;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company by ID
         * @summary Get company
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        byId: async (companyId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Company/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Open a company claim
         * @summary Open company claim
         * @param {CreateClaimDto} [createClaimDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim: async (createClaimDto?: CreateClaimDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Company/OpenClaim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClaimDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect current user to a company
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectUser: async (companyId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Company/DisconnectUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search company by company name from Dnb for onboarding
         * @summary Search potential matched companies from Dnb
         * @param {string} name 
         * @param {string} countryCode3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedCompany: async (name: string, countryCode3: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('matchedCompany', 'name', name)
            // verify required parameter 'countryCode3' is not null or undefined
            assertParamExists('matchedCompany', 'countryCode3', countryCode3)
            const localVarPath = `/api/Company/MatchedCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (countryCode3 !== undefined) {
                localVarQueryParameter['countryCode3'] = countryCode3;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks the scoring state of a list of companies by their ID
         * @summary Poll score for a list of companies
         * @param {string} id 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollCompanyCollectionScoreById: async (id: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pollCompanyCollectionScoreById', 'id', id)
            const localVarPath = `/api/Company/{id}/PollScoreMany`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll scoring state by a company ID
         * @summary Poll score for a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollScoreById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pollScoreById', 'id', id)
            const localVarPath = `/api/Company/{id}/PollScore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete score information and rescore for a company
         * @summary Rescore a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescoreById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rescoreById', 'id', id)
            const localVarPath = `/api/Company/{id}/Rescore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a rescoring update for each company in companyIds collection.
         * @summary Reset and score for a set of companies
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescoreMany: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('rescoreMany', 'requestBody', requestBody)
            const localVarPath = `/api/Company/RescoreMany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete score information for a company
         * @summary Delete score information for a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetScoreById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetScoreById', 'id', id)
            const localVarPath = `/api/Company/{id}/ResetScore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset score information for each company in companyIds collection.
         * @summary Reset for a set of companies
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetScoreMany: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('resetScoreMany', 'requestBody', requestBody)
            const localVarPath = `/api/Company/ResetMany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a scoring update for each company in companyIds collection.
         * @summary Update scoring for a set of companies
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoreMany: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Company/UpdateScoreMany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a scoring update for the company and send notification to connected users
         * @summary Update scoring
         * @param {string} id 
         * @param {boolean} [notifyUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoring: async (id: string, notifyUser?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateScoring', 'id', id)
            const localVarPath = `/api/Company/{id}/UpdateScoring`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (notifyUser !== undefined) {
                localVarQueryParameter['notifyUser'] = notifyUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a scoring update for one company on behalf of another organisation
         * @summary Update scoring for a set of companies
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoringOnBehalfOfOrganisation: async (companyId?: string, organisationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Company/UpdateScoringOnBehalfOfOrganisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * Search company by registration number or company name
         * @summary Search company
         * @param {string} [query] 
         * @param {string} [countryCode3] 
         * @param {string} [externalIdentifier] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async atlasCompanySearch(query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanySearchDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.atlasCompanySearch(query, countryCode3, externalIdentifier, pageIndex, pageSize, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get company by ID
         * @summary Get company
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async byId(companyId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.byId(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Open a company claim
         * @summary Open company claim
         * @param {CreateClaimDto} [createClaimDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClaim(createClaimDto?: CreateClaimDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClaim(createClaimDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disconnect current user to a company
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectUser(companyId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectUser(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search company by company name from Dnb for onboarding
         * @summary Search potential matched companies from Dnb
         * @param {string} name 
         * @param {string} countryCode3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchedCompany(name: string, countryCode3: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyDetailedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchedCompany(name, countryCode3, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Checks the scoring state of a list of companies by their ID
         * @summary Poll score for a list of companies
         * @param {string} id 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pollCompanyCollectionScoreById(id: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyDetailedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pollCompanyCollectionScoreById(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Poll scoring state by a company ID
         * @summary Poll score for a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pollScoreById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pollScoreById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete score information and rescore for a company
         * @summary Rescore a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rescoreById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rescoreById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Trigger a rescoring update for each company in companyIds collection.
         * @summary Reset and score for a set of companies
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rescoreMany(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rescoreMany(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete score information for a company
         * @summary Delete score information for a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetScoreById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetScoreById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset score information for each company in companyIds collection.
         * @summary Reset for a set of companies
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetScoreMany(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetScoreMany(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Trigger a scoring update for each company in companyIds collection.
         * @summary Update scoring for a set of companies
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScoreMany(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScoreMany(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Trigger a scoring update for the company and send notification to connected users
         * @summary Update scoring
         * @param {string} id 
         * @param {boolean} [notifyUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScoring(id: string, notifyUser?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScoring(id, notifyUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Trigger a scoring update for one company on behalf of another organisation
         * @summary Update scoring for a set of companies
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScoringOnBehalfOfOrganisation(companyId?: string, organisationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScoringOnBehalfOfOrganisation(companyId, organisationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * Search company by registration number or company name
         * @summary Search company
         * @param {string} [query] 
         * @param {string} [countryCode3] 
         * @param {string} [externalIdentifier] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        atlasCompanySearch(query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options?: any): AxiosPromise<CompanySearchDtoQueryResultDto> {
            return localVarFp.atlasCompanySearch(query, countryCode3, externalIdentifier, pageIndex, pageSize, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company by ID
         * @summary Get company
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        byId(companyId?: string, options?: any): AxiosPromise<CompanyDetailedDto> {
            return localVarFp.byId(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Open a company claim
         * @summary Open company claim
         * @param {CreateClaimDto} [createClaimDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim(createClaimDto?: CreateClaimDto, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.createClaim(createClaimDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect current user to a company
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectUser(companyId?: string, options?: any): AxiosPromise<CompanyUserDto> {
            return localVarFp.disconnectUser(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search company by company name from Dnb for onboarding
         * @summary Search potential matched companies from Dnb
         * @param {string} name 
         * @param {string} countryCode3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchedCompany(name: string, countryCode3: string, options?: any): AxiosPromise<Array<CompanyDetailedDto>> {
            return localVarFp.matchedCompany(name, countryCode3, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks the scoring state of a list of companies by their ID
         * @summary Poll score for a list of companies
         * @param {string} id 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollCompanyCollectionScoreById(id: string, requestBody?: Array<string>, options?: any): AxiosPromise<Array<CompanyDetailedDto>> {
            return localVarFp.pollCompanyCollectionScoreById(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll scoring state by a company ID
         * @summary Poll score for a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollScoreById(id: string, options?: any): AxiosPromise<CompanyDetailedDto> {
            return localVarFp.pollScoreById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete score information and rescore for a company
         * @summary Rescore a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescoreById(id: string, options?: any): AxiosPromise<CompanyDetailedDto> {
            return localVarFp.rescoreById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a rescoring update for each company in companyIds collection.
         * @summary Reset and score for a set of companies
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescoreMany(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.rescoreMany(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete score information for a company
         * @summary Delete score information for a company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetScoreById(id: string, options?: any): AxiosPromise<CompanyDetailedDto> {
            return localVarFp.resetScoreById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset score information for each company in companyIds collection.
         * @summary Reset for a set of companies
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetScoreMany(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.resetScoreMany(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a scoring update for each company in companyIds collection.
         * @summary Update scoring for a set of companies
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoreMany(requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.updateScoreMany(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a scoring update for the company and send notification to connected users
         * @summary Update scoring
         * @param {string} id 
         * @param {boolean} [notifyUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoring(id: string, notifyUser?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.updateScoring(id, notifyUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a scoring update for one company on behalf of another organisation
         * @summary Update scoring for a set of companies
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoringOnBehalfOfOrganisation(companyId?: string, organisationId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateScoringOnBehalfOfOrganisation(companyId, organisationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * Search company by registration number or company name
     * @summary Search company
     * @param {string} [query] 
     * @param {string} [countryCode3] 
     * @param {string} [externalIdentifier] 
     * @param {number} [pageIndex] 
     * @param {number} [pageSize] 
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public atlasCompanySearch(query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).atlasCompanySearch(query, countryCode3, externalIdentifier, pageIndex, pageSize, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company by ID
     * @summary Get company
     * @param {string} [companyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public byId(companyId?: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).byId(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Open a company claim
     * @summary Open company claim
     * @param {CreateClaimDto} [createClaimDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createClaim(createClaimDto?: CreateClaimDto, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).createClaim(createClaimDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect current user to a company
     * @param {string} [companyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public disconnectUser(companyId?: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).disconnectUser(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search company by company name from Dnb for onboarding
     * @summary Search potential matched companies from Dnb
     * @param {string} name 
     * @param {string} countryCode3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public matchedCompany(name: string, countryCode3: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).matchedCompany(name, countryCode3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks the scoring state of a list of companies by their ID
     * @summary Poll score for a list of companies
     * @param {string} id 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public pollCompanyCollectionScoreById(id: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).pollCompanyCollectionScoreById(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll scoring state by a company ID
     * @summary Poll score for a company
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public pollScoreById(id: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).pollScoreById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete score information and rescore for a company
     * @summary Rescore a company
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public rescoreById(id: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).rescoreById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger a rescoring update for each company in companyIds collection.
     * @summary Reset and score for a set of companies
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public rescoreMany(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).rescoreMany(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete score information for a company
     * @summary Delete score information for a company
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public resetScoreById(id: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).resetScoreById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset score information for each company in companyIds collection.
     * @summary Reset for a set of companies
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public resetScoreMany(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).resetScoreMany(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger a scoring update for each company in companyIds collection.
     * @summary Update scoring for a set of companies
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateScoreMany(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).updateScoreMany(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger a scoring update for the company and send notification to connected users
     * @summary Update scoring
     * @param {string} id 
     * @param {boolean} [notifyUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateScoring(id: string, notifyUser?: boolean, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).updateScoring(id, notifyUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger a scoring update for one company on behalf of another organisation
     * @summary Update scoring for a set of companies
     * @param {string} [companyId] 
     * @param {string} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateScoringOnBehalfOfOrganisation(companyId?: string, organisationId?: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).updateScoringOnBehalfOfOrganisation(companyId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyListsApi - axios parameter creator
 * @export
 */
export const CompanyListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bulk add company list items
         * @param {string} id 
         * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddCompanyListItems: async (id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bulkAddCompanyListItems', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/BulkAdd`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyListItemRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a CompanyList
         * @param {CreateCompanyListRequestDto} [createCompanyListRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyList: async (createCompanyListRequestDto?: CreateCompanyListRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyLists/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyListRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a company inside a list
         * @param {string} id 
         * @param {CreateOrUpdateCompanyListItemRequestDto} [createOrUpdateCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyListItem: async (id: string, createOrUpdateCompanyListItemRequestDto?: CreateOrUpdateCompanyListItemRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createCompanyListItem', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/Items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateCompanyListItemRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompanyList', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an item from a company list
         * @param {string} id 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyListCompany: async (id: string, itemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompanyListCompany', 'id', id)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('deleteCompanyListCompany', 'itemId', itemId)
            const localVarPath = `/api/CompanyLists/{id}/Items/{itemId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyList', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated company list items of the current list
         * @param {string} id 
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyListItems: async (id: string, queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyListItems', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/Items/Search`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all CompanyLists
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyLists: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyLists/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Esg Report info for all Companies which are verified and score completed
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEsgReportData: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEsgReportData', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/EsgReportData`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link one or more Companies to this CompanyListCompany
         * @param {string} id 
         * @param {LinkCompanyDto} [linkCompanyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkCompany: async (id: string, linkCompanyDto?: LinkCompanyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('linkCompany', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/LinkCompany`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder company list items
         * @param {string} id 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        reorderCompanyListItem: async (id: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reorderCompanyListItem', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/Items/Reorder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace items with a new collection
         * @param {string} id 
         * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyListItems: async (id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceCompanyListItems', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/ReplaceItems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyListItemRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rescore Verified items of a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescoreVerifiedCompanyList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rescoreVerifiedCompanyList', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/RescoreVerified`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Score a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreCompanyList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scoreCompanyList', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/Score`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Score Verified items of a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreVerifiedCompanyList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scoreVerifiedCompanyList', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}/ScoreVerified`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a CompanyList
         * @param {string} id 
         * @param {UpdateCompanyListRequestDto} [updateCompanyListRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyList: async (id: string, updateCompanyListRequestDto?: UpdateCompanyListRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompanyList', 'id', id)
            const localVarPath = `/api/CompanyLists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyListRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyListsApi - functional programming interface
 * @export
 */
export const CompanyListsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyListsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bulk add company list items
         * @param {string} id 
         * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkAddCompanyListItems(id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkAddCompanyListItems(id, createCompanyListItemRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a CompanyList
         * @param {CreateCompanyListRequestDto} [createCompanyListRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompanyList(createCompanyListRequestDto?: CreateCompanyListRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompanyList(createCompanyListRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a company inside a list
         * @param {string} id 
         * @param {CreateOrUpdateCompanyListItemRequestDto} [createOrUpdateCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompanyListItem(id: string, createOrUpdateCompanyListItemRequestDto?: CreateOrUpdateCompanyListItemRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListCompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompanyListItem(id, createOrUpdateCompanyListItemRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompanyList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompanyList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an item from a company list
         * @param {string} id 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompanyListCompany(id: string, itemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompanyListCompany(id, itemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get paginated company list items of the current list
         * @param {string} id 
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyListItems(id: string, queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListCompanyDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyListItems(id, queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve all CompanyLists
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyLists(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyLists(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Esg Report info for all Companies which are verified and score completed
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEsgReportData(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KosmosReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEsgReportData(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Link one or more Companies to this CompanyListCompany
         * @param {string} id 
         * @param {LinkCompanyDto} [linkCompanyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkCompany(id: string, linkCompanyDto?: LinkCompanyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListCompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkCompany(id, linkCompanyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reorder company list items
         * @param {string} id 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async reorderCompanyListItem(id: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderCompanyListItem(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace items with a new collection
         * @param {string} id 
         * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceCompanyListItems(id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceCompanyListItems(id, createCompanyListItemRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Rescore Verified items of a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rescoreVerifiedCompanyList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rescoreVerifiedCompanyList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Score a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreCompanyList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreCompanyList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Score Verified items of a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreVerifiedCompanyList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreVerifiedCompanyList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a CompanyList
         * @param {string} id 
         * @param {UpdateCompanyListRequestDto} [updateCompanyListRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyList(id: string, updateCompanyListRequestDto?: UpdateCompanyListRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyList(id, updateCompanyListRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyListsApi - factory interface
 * @export
 */
export const CompanyListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyListsApiFp(configuration)
    return {
        /**
         * 
         * @summary Bulk add company list items
         * @param {string} id 
         * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddCompanyListItems(id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.bulkAddCompanyListItems(id, createCompanyListItemRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a CompanyList
         * @param {CreateCompanyListRequestDto} [createCompanyListRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyList(createCompanyListRequestDto?: CreateCompanyListRequestDto, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.createCompanyList(createCompanyListRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a company inside a list
         * @param {string} id 
         * @param {CreateOrUpdateCompanyListItemRequestDto} [createOrUpdateCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyListItem(id: string, createOrUpdateCompanyListItemRequestDto?: CreateOrUpdateCompanyListItemRequestDto, options?: any): AxiosPromise<CompanyListCompanyDto> {
            return localVarFp.createCompanyListItem(id, createOrUpdateCompanyListItemRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyList(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCompanyList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an item from a company list
         * @param {string} id 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyListCompany(id: string, itemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCompanyListCompany(id, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyList(id: string, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.getCompanyList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated company list items of the current list
         * @param {string} id 
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyListItems(id: string, queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<CompanyListCompanyDtoQueryResultDto> {
            return localVarFp.getCompanyListItems(id, queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all CompanyLists
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyLists(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<CompanyListDtoQueryResultDto> {
            return localVarFp.getCompanyLists(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Esg Report info for all Companies which are verified and score completed
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEsgReportData(id: string, options?: any): AxiosPromise<Array<KosmosReportDto>> {
            return localVarFp.getEsgReportData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link one or more Companies to this CompanyListCompany
         * @param {string} id 
         * @param {LinkCompanyDto} [linkCompanyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkCompany(id: string, linkCompanyDto?: LinkCompanyDto, options?: any): AxiosPromise<CompanyListCompanyDto> {
            return localVarFp.linkCompany(id, linkCompanyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder company list items
         * @param {string} id 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        reorderCompanyListItem(id: string, requestBody?: Array<string>, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.reorderCompanyListItem(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace items with a new collection
         * @param {string} id 
         * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyListItems(id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.replaceCompanyListItems(id, createCompanyListItemRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rescore Verified items of a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescoreVerifiedCompanyList(id: string, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.rescoreVerifiedCompanyList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Score a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreCompanyList(id: string, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.scoreCompanyList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Score Verified items of a CompanyList
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreVerifiedCompanyList(id: string, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.scoreVerifiedCompanyList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a CompanyList
         * @param {string} id 
         * @param {UpdateCompanyListRequestDto} [updateCompanyListRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyList(id: string, updateCompanyListRequestDto?: UpdateCompanyListRequestDto, options?: any): AxiosPromise<CompanyListDto> {
            return localVarFp.updateCompanyList(id, updateCompanyListRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyListsApi - object-oriented interface
 * @export
 * @class CompanyListsApi
 * @extends {BaseAPI}
 */
export class CompanyListsApi extends BaseAPI {
    /**
     * 
     * @summary Bulk add company list items
     * @param {string} id 
     * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public bulkAddCompanyListItems(id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).bulkAddCompanyListItems(id, createCompanyListItemRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a CompanyList
     * @param {CreateCompanyListRequestDto} [createCompanyListRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public createCompanyList(createCompanyListRequestDto?: CreateCompanyListRequestDto, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).createCompanyList(createCompanyListRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a company inside a list
     * @param {string} id 
     * @param {CreateOrUpdateCompanyListItemRequestDto} [createOrUpdateCompanyListItemRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public createCompanyListItem(id: string, createOrUpdateCompanyListItemRequestDto?: CreateOrUpdateCompanyListItemRequestDto, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).createCompanyListItem(id, createOrUpdateCompanyListItemRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a CompanyList
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public deleteCompanyList(id: string, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).deleteCompanyList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an item from a company list
     * @param {string} id 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public deleteCompanyListCompany(id: string, itemId: string, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).deleteCompanyListCompany(id, itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a CompanyList
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public getCompanyList(id: string, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).getCompanyList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated company list items of the current list
     * @param {string} id 
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public getCompanyListItems(id: string, queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).getCompanyListItems(id, queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all CompanyLists
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public getCompanyLists(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).getCompanyLists(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Esg Report info for all Companies which are verified and score completed
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public getEsgReportData(id: string, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).getEsgReportData(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link one or more Companies to this CompanyListCompany
     * @param {string} id 
     * @param {LinkCompanyDto} [linkCompanyDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public linkCompany(id: string, linkCompanyDto?: LinkCompanyDto, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).linkCompany(id, linkCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder company list items
     * @param {string} id 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public reorderCompanyListItem(id: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).reorderCompanyListItem(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace items with a new collection
     * @param {string} id 
     * @param {Array<CreateCompanyListItemRequestDto>} [createCompanyListItemRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public replaceCompanyListItems(id: string, createCompanyListItemRequestDto?: Array<CreateCompanyListItemRequestDto>, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).replaceCompanyListItems(id, createCompanyListItemRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rescore Verified items of a CompanyList
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public rescoreVerifiedCompanyList(id: string, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).rescoreVerifiedCompanyList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Score a CompanyList
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public scoreCompanyList(id: string, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).scoreCompanyList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Score Verified items of a CompanyList
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public scoreVerifiedCompanyList(id: string, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).scoreVerifiedCompanyList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a CompanyList
     * @param {string} id 
     * @param {UpdateCompanyListRequestDto} [updateCompanyListRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyListsApi
     */
    public updateCompanyList(id: string, updateCompanyListRequestDto?: UpdateCompanyListRequestDto, options?: AxiosRequestConfig) {
        return CompanyListsApiFp(this.configuration).updateCompanyList(id, updateCompanyListRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [locale] 
         * @param {string} [nameSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContent: async (locale?: string, nameSpace?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Content/GetContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (nameSpace !== undefined) {
                localVarQueryParameter['nameSpace'] = nameSpace;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackLanguage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Content/GetFallbackLanguage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [locale] 
         * @param {string} [nameSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelContentFromDb: async (locale?: string, nameSpace?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Content/GetLabelContentFromDb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (nameSpace !== undefined) {
                localVarQueryParameter['nameSpace'] = nameSpace;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the list of currently available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Content/GetLanguages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [locale] 
         * @param {string} [nameSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContent(locale?: string, nameSpace?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContent(locale, nameSpace, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFallbackLanguage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFallbackLanguage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [locale] 
         * @param {string} [nameSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLabelContentFromDb(locale?: string, nameSpace?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLabelContentFromDb(locale, nameSpace, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the list of currently available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLanguages(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLanguages(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [locale] 
         * @param {string} [nameSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContent(locale?: string, nameSpace?: string, options?: any): AxiosPromise<Array<ContentDto>> {
            return localVarFp.getContent(locale, nameSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackLanguage(options?: any): AxiosPromise<string> {
            return localVarFp.getFallbackLanguage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [locale] 
         * @param {string} [nameSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelContentFromDb(locale?: string, nameSpace?: string, options?: any): AxiosPromise<ContentDto> {
            return localVarFp.getLabelContentFromDb(locale, nameSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of currently available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getLanguages(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
    /**
     * 
     * @param {string} [locale] 
     * @param {string} [nameSpace] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getContent(locale?: string, nameSpace?: string, options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).getContent(locale, nameSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getFallbackLanguage(options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).getFallbackLanguage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [locale] 
     * @param {string} [nameSpace] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getLabelContentFromDb(locale?: string, nameSpace?: string, options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).getLabelContentFromDb(locale, nameSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the list of currently available languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getLanguages(options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).getLanguages(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GeolocationApi - axios parameter creator
 * @export
 */
export const GeolocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [address] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: async (address?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Geolocation/GetPosition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeolocationApi - functional programming interface
 * @export
 */
export const GeolocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeolocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [address] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPosition(address?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleDoubleValueTuple>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPosition(address, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeolocationApi - factory interface
 * @export
 */
export const GeolocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeolocationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [address] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(address?: string, options?: any): AxiosPromise<DoubleDoubleValueTuple> {
            return localVarFp.getPosition(address, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeolocationApi - object-oriented interface
 * @export
 * @class GeolocationApi
 * @extends {BaseAPI}
 */
export class GeolocationApi extends BaseAPI {
    /**
     * 
     * @param {string} [address] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public getPosition(address?: string, options?: AxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).getPosition(address, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KosmosCompanyApi - axios parameter creator
 * @export
 */
export const KosmosCompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search company by registration number or company name, returns the sustainability score of the company
         * @summary Search company
         * @param {string} [query] 
         * @param {string} [countryCode3] 
         * @param {string} [externalIdentifier] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearch: async (query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (countryCode3 !== undefined) {
                localVarQueryParameter['countryCode3'] = countryCode3;
            }

            if (externalIdentifier !== undefined) {
                localVarQueryParameter['externalIdentifier'] = externalIdentifier;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search company by external provider ID, e.g. DUNS number
         * @summary Search company by external provider ID
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearchById: async (query: string, countryCode3?: string, pageIndex?: number, pageSize?: number, order?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('companySearchById', 'query', query)
            const localVarPath = `/SearchById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (countryCode3 !== undefined) {
                localVarQueryParameter['countryCode3'] = countryCode3;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search company by company Ids
         * @summary Search company by ids
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearchByIds: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/SearchWithIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get currently scored company filtered by organisationId
         * @summary Get scored company of this Organisation
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationScoredCompany: async (companyId?: string, organisationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/GetOrganisationScoredCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get currently scored companies filtered by organisationId
         * @summary Get scored companies of this Organisation
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoredCompanies: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/GetScoredCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get currently scored company report in json format filtered by organisationId
         * @summary Get scored company reports of this Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoredCompanyReports: async (queryAndSortDto?: QueryAndSortDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/GetScoredCompanyReports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an sg assignment for this kosmos company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSgAssignmentByKosmosCompany: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSgAssignmentByKosmosCompany', 'id', id)
            const localVarPath = `/{id}/SmartGovernanceAssignment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search company by Address, returns the sustainability score of the company
         * @summary Search company by address
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {string} [addressRegion] 
         * @param {string} [streetAddressLine1] 
         * @param {string} [addressLocality] 
         * @param {string} [postalCode] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByAddress: async (query: string, countryCode3?: string, addressRegion?: string, streetAddressLine1?: string, addressLocality?: string, postalCode?: string, pageIndex?: number, pageSize?: number, order?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchByAddress', 'query', query)
            const localVarPath = `/SearchByAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (countryCode3 !== undefined) {
                localVarQueryParameter['countryCode3'] = countryCode3;
            }

            if (addressRegion !== undefined) {
                localVarQueryParameter['addressRegion'] = addressRegion;
            }

            if (streetAddressLine1 !== undefined) {
                localVarQueryParameter['streetAddressLine1'] = streetAddressLine1;
            }

            if (addressLocality !== undefined) {
                localVarQueryParameter['addressLocality'] = addressLocality;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postalCode'] = postalCode;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search company by geolocation, returns the sustainability score of the company
         * @summary Search company by geolocation
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {number} [radiusLat] 
         * @param {number} [radiusLon] 
         * @param {string} [radiusPostalCode] 
         * @param {number} [radiusDistance] 
         * @param {string} [radiusUnit] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByGeolocation: async (query: string, countryCode3?: string, radiusLat?: number, radiusLon?: number, radiusPostalCode?: string, radiusDistance?: number, radiusUnit?: string, pageIndex?: number, pageSize?: number, order?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchByGeolocation', 'query', query)
            const localVarPath = `/SearchByGeolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (countryCode3 !== undefined) {
                localVarQueryParameter['countryCode3'] = countryCode3;
            }

            if (radiusLat !== undefined) {
                localVarQueryParameter['radiusLat'] = radiusLat;
            }

            if (radiusLon !== undefined) {
                localVarQueryParameter['radiusLon'] = radiusLon;
            }

            if (radiusPostalCode !== undefined) {
                localVarQueryParameter['radiusPostalCode'] = radiusPostalCode;
            }

            if (radiusDistance !== undefined) {
                localVarQueryParameter['radiusDistance'] = radiusDistance;
            }

            if (radiusUnit !== undefined) {
                localVarQueryParameter['radiusUnit'] = radiusUnit;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KosmosCompanyApi - functional programming interface
 * @export
 */
export const KosmosCompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KosmosCompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * Search company by registration number or company name, returns the sustainability score of the company
         * @summary Search company
         * @param {string} [query] 
         * @param {string} [countryCode3] 
         * @param {string} [externalIdentifier] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companySearch(query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanySearchDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companySearch(query, countryCode3, externalIdentifier, pageIndex, pageSize, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search company by external provider ID, e.g. DUNS number
         * @summary Search company by external provider ID
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companySearchById(query: string, countryCode3?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanySearchDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companySearchById(query, countryCode3, pageIndex, pageSize, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search company by company Ids
         * @summary Search company by ids
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companySearchByIds(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanySearchDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companySearchByIds(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get currently scored company filtered by organisationId
         * @summary Get scored company of this Organisation
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisationScoredCompany(companyId?: string, organisationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationScoredCompaniesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganisationScoredCompany(companyId, organisationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get currently scored companies filtered by organisationId
         * @summary Get scored companies of this Organisation
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoredCompanies(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationScoredCompaniesDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoredCompanies(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get currently scored company report in json format filtered by organisationId
         * @summary Get scored company reports of this Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoredCompanyReports(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KosmosReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoredCompanyReports(queryAndSortDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an sg assignment for this kosmos company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSgAssignmentByKosmosCompany(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSgAssignmentByKosmosCompany(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search company by Address, returns the sustainability score of the company
         * @summary Search company by address
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {string} [addressRegion] 
         * @param {string} [streetAddressLine1] 
         * @param {string} [addressLocality] 
         * @param {string} [postalCode] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByAddress(query: string, countryCode3?: string, addressRegion?: string, streetAddressLine1?: string, addressLocality?: string, postalCode?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDetailedDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByAddress(query, countryCode3, addressRegion, streetAddressLine1, addressLocality, postalCode, pageIndex, pageSize, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search company by geolocation, returns the sustainability score of the company
         * @summary Search company by geolocation
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {number} [radiusLat] 
         * @param {number} [radiusLon] 
         * @param {string} [radiusPostalCode] 
         * @param {number} [radiusDistance] 
         * @param {string} [radiusUnit] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByGeolocation(query: string, countryCode3?: string, radiusLat?: number, radiusLon?: number, radiusPostalCode?: string, radiusDistance?: number, radiusUnit?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDetailedDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByGeolocation(query, countryCode3, radiusLat, radiusLon, radiusPostalCode, radiusDistance, radiusUnit, pageIndex, pageSize, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KosmosCompanyApi - factory interface
 * @export
 */
export const KosmosCompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KosmosCompanyApiFp(configuration)
    return {
        /**
         * Search company by registration number or company name, returns the sustainability score of the company
         * @summary Search company
         * @param {string} [query] 
         * @param {string} [countryCode3] 
         * @param {string} [externalIdentifier] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearch(query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options?: any): AxiosPromise<CompanySearchDtoQueryResultDto> {
            return localVarFp.companySearch(query, countryCode3, externalIdentifier, pageIndex, pageSize, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Search company by external provider ID, e.g. DUNS number
         * @summary Search company by external provider ID
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearchById(query: string, countryCode3?: string, pageIndex?: number, pageSize?: number, order?: string, options?: any): AxiosPromise<CompanySearchDtoQueryResultDto> {
            return localVarFp.companySearchById(query, countryCode3, pageIndex, pageSize, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Search company by company Ids
         * @summary Search company by ids
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearchByIds(ids?: Array<string>, options?: any): AxiosPromise<Array<CompanySearchDto>> {
            return localVarFp.companySearchByIds(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get currently scored company filtered by organisationId
         * @summary Get scored company of this Organisation
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationScoredCompany(companyId?: string, organisationId?: string, options?: any): AxiosPromise<OrganisationScoredCompaniesDto> {
            return localVarFp.getOrganisationScoredCompany(companyId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get currently scored companies filtered by organisationId
         * @summary Get scored companies of this Organisation
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoredCompanies(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<OrganisationScoredCompaniesDtoQueryResultDto> {
            return localVarFp.getScoredCompanies(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get currently scored company report in json format filtered by organisationId
         * @summary Get scored company reports of this Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoredCompanyReports(queryAndSortDto?: QueryAndSortDto, options?: any): AxiosPromise<Array<KosmosReportDto>> {
            return localVarFp.getScoredCompanyReports(queryAndSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an sg assignment for this kosmos company
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSgAssignmentByKosmosCompany(id: string, options?: any): AxiosPromise<OrganisationAssignmentDto> {
            return localVarFp.getSgAssignmentByKosmosCompany(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search company by Address, returns the sustainability score of the company
         * @summary Search company by address
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {string} [addressRegion] 
         * @param {string} [streetAddressLine1] 
         * @param {string} [addressLocality] 
         * @param {string} [postalCode] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByAddress(query: string, countryCode3?: string, addressRegion?: string, streetAddressLine1?: string, addressLocality?: string, postalCode?: string, pageIndex?: number, pageSize?: number, order?: string, options?: any): AxiosPromise<CompanyDetailedDtoQueryResultDto> {
            return localVarFp.searchByAddress(query, countryCode3, addressRegion, streetAddressLine1, addressLocality, postalCode, pageIndex, pageSize, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Search company by geolocation, returns the sustainability score of the company
         * @summary Search company by geolocation
         * @param {string} query 
         * @param {string} [countryCode3] 
         * @param {number} [radiusLat] 
         * @param {number} [radiusLon] 
         * @param {string} [radiusPostalCode] 
         * @param {number} [radiusDistance] 
         * @param {string} [radiusUnit] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByGeolocation(query: string, countryCode3?: string, radiusLat?: number, radiusLon?: number, radiusPostalCode?: string, radiusDistance?: number, radiusUnit?: string, pageIndex?: number, pageSize?: number, order?: string, options?: any): AxiosPromise<CompanyDetailedDtoQueryResultDto> {
            return localVarFp.searchByGeolocation(query, countryCode3, radiusLat, radiusLon, radiusPostalCode, radiusDistance, radiusUnit, pageIndex, pageSize, order, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KosmosCompanyApi - object-oriented interface
 * @export
 * @class KosmosCompanyApi
 * @extends {BaseAPI}
 */
export class KosmosCompanyApi extends BaseAPI {
    /**
     * Search company by registration number or company name, returns the sustainability score of the company
     * @summary Search company
     * @param {string} [query] 
     * @param {string} [countryCode3] 
     * @param {string} [externalIdentifier] 
     * @param {number} [pageIndex] 
     * @param {number} [pageSize] 
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public companySearch(query?: string, countryCode3?: string, externalIdentifier?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).companySearch(query, countryCode3, externalIdentifier, pageIndex, pageSize, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search company by external provider ID, e.g. DUNS number
     * @summary Search company by external provider ID
     * @param {string} query 
     * @param {string} [countryCode3] 
     * @param {number} [pageIndex] 
     * @param {number} [pageSize] 
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public companySearchById(query: string, countryCode3?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).companySearchById(query, countryCode3, pageIndex, pageSize, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search company by company Ids
     * @summary Search company by ids
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public companySearchByIds(ids?: Array<string>, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).companySearchByIds(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get currently scored company filtered by organisationId
     * @summary Get scored company of this Organisation
     * @param {string} [companyId] 
     * @param {string} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public getOrganisationScoredCompany(companyId?: string, organisationId?: string, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).getOrganisationScoredCompany(companyId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get currently scored companies filtered by organisationId
     * @summary Get scored companies of this Organisation
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public getScoredCompanies(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).getScoredCompanies(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get currently scored company report in json format filtered by organisationId
     * @summary Get scored company reports of this Organisation
     * @param {QueryAndSortDto} [queryAndSortDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public getScoredCompanyReports(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).getScoredCompanyReports(queryAndSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an sg assignment for this kosmos company
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public getSgAssignmentByKosmosCompany(id: string, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).getSgAssignmentByKosmosCompany(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search company by Address, returns the sustainability score of the company
     * @summary Search company by address
     * @param {string} query 
     * @param {string} [countryCode3] 
     * @param {string} [addressRegion] 
     * @param {string} [streetAddressLine1] 
     * @param {string} [addressLocality] 
     * @param {string} [postalCode] 
     * @param {number} [pageIndex] 
     * @param {number} [pageSize] 
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public searchByAddress(query: string, countryCode3?: string, addressRegion?: string, streetAddressLine1?: string, addressLocality?: string, postalCode?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).searchByAddress(query, countryCode3, addressRegion, streetAddressLine1, addressLocality, postalCode, pageIndex, pageSize, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search company by geolocation, returns the sustainability score of the company
     * @summary Search company by geolocation
     * @param {string} query 
     * @param {string} [countryCode3] 
     * @param {number} [radiusLat] 
     * @param {number} [radiusLon] 
     * @param {string} [radiusPostalCode] 
     * @param {number} [radiusDistance] 
     * @param {string} [radiusUnit] 
     * @param {number} [pageIndex] 
     * @param {number} [pageSize] 
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosCompanyApi
     */
    public searchByGeolocation(query: string, countryCode3?: string, radiusLat?: number, radiusLon?: number, radiusPostalCode?: string, radiusDistance?: number, radiusUnit?: string, pageIndex?: number, pageSize?: number, order?: string, options?: AxiosRequestConfig) {
        return KosmosCompanyApiFp(this.configuration).searchByGeolocation(query, countryCode3, radiusLat, radiusLon, radiusPostalCode, radiusDistance, radiusUnit, pageIndex, pageSize, order, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KosmosReportApi - axios parameter creator
 * @export
 */
export const KosmosReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets a combined PDF for both automated ESG score report and smart governance report
         * @summary Gets a combined PdF Kosmos report
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {boolean} [debug] 
         * @param {PdfStyleDto} [pdfStyleType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCombinedPdfKosmosReportById: async (companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/KosmosReport/GetCombinedKosmosPdfReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }

            if (pdfStyleType !== undefined) {
                localVarQueryParameter['pdfStyleType'] = pdfStyleType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a summary or full report
         * @summary Gets a HTML report for company
         * @param {string} [companyId] 
         * @param {ReportTypeDto} [reportType] 
         * @param {string} [locale] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyHtmlReportById: async (companyId?: string, reportType?: ReportTypeDto, locale?: string, token?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/KosmosReport/GetHtml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a full Kosmos report
         * @summary Gets a Kosmos report for a company
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyKosmosReportById: async (companyId?: string, organisationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/KosmosReport/GetKosmosReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a full Kosmos report
         * @summary Gets a PdF Kosmos report for a company
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {boolean} [debug] 
         * @param {PdfStyleDto} [pdfStyleType] 
         * @param {ReportTypeDto} [reportType] 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPdfKosmosReportById: async (companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, reportType?: ReportTypeDto, locale?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/KosmosReport/GetKosmosPdfReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }

            if (pdfStyleType !== undefined) {
                localVarQueryParameter['pdfStyleType'] = pdfStyleType;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a full Kosmos report, including both the onboarded and self-governance
         * @summary Gets a Kosmos report for a company, including both the onboarded and self-governance part
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelfGovernanceReportById: async (companyId?: string, organisationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/KosmosReport/GetSelfGovernanceReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KosmosReportApi - functional programming interface
 * @export
 */
export const KosmosReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KosmosReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets a combined PDF for both automated ESG score report and smart governance report
         * @summary Gets a combined PdF Kosmos report
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {boolean} [debug] 
         * @param {PdfStyleDto} [pdfStyleType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyCombinedPdfKosmosReportById(companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyCombinedPdfKosmosReportById(companyId, organisationId, debug, pdfStyleType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a summary or full report
         * @summary Gets a HTML report for company
         * @param {string} [companyId] 
         * @param {ReportTypeDto} [reportType] 
         * @param {string} [locale] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyHtmlReportById(companyId?: string, reportType?: ReportTypeDto, locale?: string, token?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyHtmlReportById(companyId, reportType, locale, token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a full Kosmos report
         * @summary Gets a Kosmos report for a company
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyKosmosReportById(companyId?: string, organisationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KosmosReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyKosmosReportById(companyId, organisationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a full Kosmos report
         * @summary Gets a PdF Kosmos report for a company
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {boolean} [debug] 
         * @param {PdfStyleDto} [pdfStyleType] 
         * @param {ReportTypeDto} [reportType] 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyPdfKosmosReportById(companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, reportType?: ReportTypeDto, locale?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyPdfKosmosReportById(companyId, organisationId, debug, pdfStyleType, reportType, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a full Kosmos report, including both the onboarded and self-governance
         * @summary Gets a Kosmos report for a company, including both the onboarded and self-governance part
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSelfGovernanceReportById(companyId?: string, organisationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KosmosReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSelfGovernanceReportById(companyId, organisationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KosmosReportApi - factory interface
 * @export
 */
export const KosmosReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KosmosReportApiFp(configuration)
    return {
        /**
         * Gets a combined PDF for both automated ESG score report and smart governance report
         * @summary Gets a combined PdF Kosmos report
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {boolean} [debug] 
         * @param {PdfStyleDto} [pdfStyleType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCombinedPdfKosmosReportById(companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, options?: any): AxiosPromise<void> {
            return localVarFp.getCompanyCombinedPdfKosmosReportById(companyId, organisationId, debug, pdfStyleType, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a summary or full report
         * @summary Gets a HTML report for company
         * @param {string} [companyId] 
         * @param {ReportTypeDto} [reportType] 
         * @param {string} [locale] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyHtmlReportById(companyId?: string, reportType?: ReportTypeDto, locale?: string, token?: string, options?: any): AxiosPromise<void> {
            return localVarFp.getCompanyHtmlReportById(companyId, reportType, locale, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a full Kosmos report
         * @summary Gets a Kosmos report for a company
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyKosmosReportById(companyId?: string, organisationId?: string, options?: any): AxiosPromise<KosmosReportDto> {
            return localVarFp.getCompanyKosmosReportById(companyId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a full Kosmos report
         * @summary Gets a PdF Kosmos report for a company
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {boolean} [debug] 
         * @param {PdfStyleDto} [pdfStyleType] 
         * @param {ReportTypeDto} [reportType] 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPdfKosmosReportById(companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, reportType?: ReportTypeDto, locale?: string, options?: any): AxiosPromise<void> {
            return localVarFp.getCompanyPdfKosmosReportById(companyId, organisationId, debug, pdfStyleType, reportType, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a full Kosmos report, including both the onboarded and self-governance
         * @summary Gets a Kosmos report for a company, including both the onboarded and self-governance part
         * @param {string} [companyId] 
         * @param {string} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelfGovernanceReportById(companyId?: string, organisationId?: string, options?: any): AxiosPromise<Array<KosmosReportDto>> {
            return localVarFp.getSelfGovernanceReportById(companyId, organisationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KosmosReportApi - object-oriented interface
 * @export
 * @class KosmosReportApi
 * @extends {BaseAPI}
 */
export class KosmosReportApi extends BaseAPI {
    /**
     * Gets a combined PDF for both automated ESG score report and smart governance report
     * @summary Gets a combined PdF Kosmos report
     * @param {string} [companyId] 
     * @param {string} [organisationId] 
     * @param {boolean} [debug] 
     * @param {PdfStyleDto} [pdfStyleType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosReportApi
     */
    public getCompanyCombinedPdfKosmosReportById(companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, options?: AxiosRequestConfig) {
        return KosmosReportApiFp(this.configuration).getCompanyCombinedPdfKosmosReportById(companyId, organisationId, debug, pdfStyleType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a summary or full report
     * @summary Gets a HTML report for company
     * @param {string} [companyId] 
     * @param {ReportTypeDto} [reportType] 
     * @param {string} [locale] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosReportApi
     */
    public getCompanyHtmlReportById(companyId?: string, reportType?: ReportTypeDto, locale?: string, token?: string, options?: AxiosRequestConfig) {
        return KosmosReportApiFp(this.configuration).getCompanyHtmlReportById(companyId, reportType, locale, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a full Kosmos report
     * @summary Gets a Kosmos report for a company
     * @param {string} [companyId] 
     * @param {string} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosReportApi
     */
    public getCompanyKosmosReportById(companyId?: string, organisationId?: string, options?: AxiosRequestConfig) {
        return KosmosReportApiFp(this.configuration).getCompanyKosmosReportById(companyId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a full Kosmos report
     * @summary Gets a PdF Kosmos report for a company
     * @param {string} [companyId] 
     * @param {string} [organisationId] 
     * @param {boolean} [debug] 
     * @param {PdfStyleDto} [pdfStyleType] 
     * @param {ReportTypeDto} [reportType] 
     * @param {string} [locale] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosReportApi
     */
    public getCompanyPdfKosmosReportById(companyId?: string, organisationId?: string, debug?: boolean, pdfStyleType?: PdfStyleDto, reportType?: ReportTypeDto, locale?: string, options?: AxiosRequestConfig) {
        return KosmosReportApiFp(this.configuration).getCompanyPdfKosmosReportById(companyId, organisationId, debug, pdfStyleType, reportType, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a full Kosmos report, including both the onboarded and self-governance
     * @summary Gets a Kosmos report for a company, including both the onboarded and self-governance part
     * @param {string} [companyId] 
     * @param {string} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KosmosReportApi
     */
    public getSelfGovernanceReportById(companyId?: string, organisationId?: string, options?: AxiosRequestConfig) {
        return KosmosReportApiFp(this.configuration).getSelfGovernanceReportById(companyId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all ScoringInformation as notifications grouped by scoring state
         * @summary Fetch all notifications
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (state?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notification/All`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark all notification read
         * @summary mark all notification read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotification: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notification/MarkAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark one notification read or unread
         * @summary mark a notification read or unread
         * @param {MarkNotificationRequestDto} [markNotificationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotification: async (markNotificationRequestDto?: MarkNotificationRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notification/Mark`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all ScoringInformation as notifications grouped by scoring state
         * @summary Fetch all notifications
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(state?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Mark all notification read
         * @summary mark all notification read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllNotification(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllNotification(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Mark one notification read or unread
         * @summary mark a notification read or unread
         * @param {MarkNotificationRequestDto} [markNotificationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotification(markNotificationRequestDto?: MarkNotificationRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotification(markNotificationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * Get all ScoringInformation as notifications grouped by scoring state
         * @summary Fetch all notifications
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(state?: string, options?: any): AxiosPromise<NotificationSummaryDto> {
            return localVarFp.getNotifications(state, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark all notification read
         * @summary mark all notification read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotification(options?: any): AxiosPromise<void> {
            return localVarFp.markAllNotification(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark one notification read or unread
         * @summary mark a notification read or unread
         * @param {MarkNotificationRequestDto} [markNotificationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotification(markNotificationRequestDto?: MarkNotificationRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.markNotification(markNotificationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * Get all ScoringInformation as notifications grouped by scoring state
     * @summary Fetch all notifications
     * @param {string} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotifications(state?: string, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotifications(state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark all notification read
     * @summary mark all notification read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public markAllNotification(options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).markAllNotification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark one notification read or unread
     * @summary mark a notification read or unread
     * @param {MarkNotificationRequestDto} [markNotificationRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public markNotification(markNotificationRequestDto?: MarkNotificationRequestDto, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).markNotification(markNotificationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationAssignmentsApi - axios parameter creator
 * @export
 */
export const OrganisationAssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrganisationAssignment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acceptOrganisationAssignment', 'id', id)
            const localVarPath = `/api/OrganisationAssignments/{id}/Accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a SG assignment
         * @param {CreateOrganisationAssignmentRequestDto} [createOrganisationAssignmentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganisationAssignment: async (createOrganisationAssignmentRequestDto?: CreateOrganisationAssignmentRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationAssignments/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganisationAssignmentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganisationAssignment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrganisationAssignment', 'id', id)
            const localVarPath = `/api/OrganisationAssignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all organisation SG assignments
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganisationAssignments: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationAssignments/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all organisation SG assignments
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganisationAssignmentsAssignedToMe: async (queryAndSortDto?: QueryAndSortDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationAssignments/GetAllAssignedToMe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationAssignment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganisationAssignment', 'id', id)
            const localVarPath = `/api/OrganisationAssignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationAssignmentsApi - functional programming interface
 * @export
 */
export const OrganisationAssignmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationAssignmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptOrganisationAssignment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptOrganisationAssignment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a SG assignment
         * @param {CreateOrganisationAssignmentRequestDto} [createOrganisationAssignmentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganisationAssignment(createOrganisationAssignmentRequestDto?: CreateOrganisationAssignmentRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganisationAssignment(createOrganisationAssignmentRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganisationAssignment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganisationAssignment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve all organisation SG assignments
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrganisationAssignments(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationAssignmentDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOrganisationAssignments(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve all organisation SG assignments
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrganisationAssignmentsAssignedToMe(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOrganisationAssignmentsAssignedToMe(queryAndSortDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisationAssignment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganisationAssignment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationAssignmentsApi - factory interface
 * @export
 */
export const OrganisationAssignmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationAssignmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrganisationAssignment(id: string, options?: any): AxiosPromise<OrganisationAssignmentDto> {
            return localVarFp.acceptOrganisationAssignment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a SG assignment
         * @param {CreateOrganisationAssignmentRequestDto} [createOrganisationAssignmentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganisationAssignment(createOrganisationAssignmentRequestDto?: CreateOrganisationAssignmentRequestDto, options?: any): AxiosPromise<OrganisationAssignmentDto> {
            return localVarFp.createOrganisationAssignment(createOrganisationAssignmentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganisationAssignment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteOrganisationAssignment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all organisation SG assignments
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganisationAssignments(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<OrganisationAssignmentDtoQueryResultDto> {
            return localVarFp.getAllOrganisationAssignments(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all organisation SG assignments
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganisationAssignmentsAssignedToMe(queryAndSortDto?: QueryAndSortDto, options?: any): AxiosPromise<Array<OrganisationAssignmentDto>> {
            return localVarFp.getAllOrganisationAssignmentsAssignedToMe(queryAndSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an organisation assignment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationAssignment(id: string, options?: any): AxiosPromise<OrganisationAssignmentDto> {
            return localVarFp.getOrganisationAssignment(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationAssignmentsApi - object-oriented interface
 * @export
 * @class OrganisationAssignmentsApi
 * @extends {BaseAPI}
 */
export class OrganisationAssignmentsApi extends BaseAPI {
    /**
     * 
     * @summary Accept an organisation assignment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAssignmentsApi
     */
    public acceptOrganisationAssignment(id: string, options?: AxiosRequestConfig) {
        return OrganisationAssignmentsApiFp(this.configuration).acceptOrganisationAssignment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a SG assignment
     * @param {CreateOrganisationAssignmentRequestDto} [createOrganisationAssignmentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAssignmentsApi
     */
    public createOrganisationAssignment(createOrganisationAssignmentRequestDto?: CreateOrganisationAssignmentRequestDto, options?: AxiosRequestConfig) {
        return OrganisationAssignmentsApiFp(this.configuration).createOrganisationAssignment(createOrganisationAssignmentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an organisation assignment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAssignmentsApi
     */
    public deleteOrganisationAssignment(id: string, options?: AxiosRequestConfig) {
        return OrganisationAssignmentsApiFp(this.configuration).deleteOrganisationAssignment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all organisation SG assignments
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAssignmentsApi
     */
    public getAllOrganisationAssignments(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return OrganisationAssignmentsApiFp(this.configuration).getAllOrganisationAssignments(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all organisation SG assignments
     * @param {QueryAndSortDto} [queryAndSortDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAssignmentsApi
     */
    public getAllOrganisationAssignmentsAssignedToMe(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig) {
        return OrganisationAssignmentsApiFp(this.configuration).getAllOrganisationAssignmentsAssignedToMe(queryAndSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an organisation assignment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAssignmentsApi
     */
    public getOrganisationAssignment(id: string, options?: AxiosRequestConfig) {
        return OrganisationAssignmentsApiFp(this.configuration).getOrganisationAssignment(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationScoredCompaniesApi - axios parameter creator
 * @export
 */
export const OrganisationScoredCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Extract Scored Companies by Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractScoredCompanies: async (queryAndSortDto?: QueryAndSortDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationScoredCompanies/ExtractScoredCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extract Scored SmartGovernance Companies by Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractScoredSmartGovernanceCompanies: async (queryAndSortDto?: QueryAndSortDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationScoredCompanies/ExtractScoredSmartGovernanceCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Scored Companies by Organisation Paginated
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScoredCompanies: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationScoredCompanies/ListScoredCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationScoredCompaniesApi - functional programming interface
 * @export
 */
export const OrganisationScoredCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationScoredCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Extract Scored Companies by Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractScoredCompanies(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationScoredCompaniesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractScoredCompanies(queryAndSortDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Extract Scored SmartGovernance Companies by Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractScoredSmartGovernanceCompanies(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationScoredCompaniesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractScoredSmartGovernanceCompanies(queryAndSortDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Scored Companies by Organisation Paginated
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listScoredCompanies(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationScoredCompaniesDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listScoredCompanies(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationScoredCompaniesApi - factory interface
 * @export
 */
export const OrganisationScoredCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationScoredCompaniesApiFp(configuration)
    return {
        /**
         * 
         * @summary Extract Scored Companies by Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractScoredCompanies(queryAndSortDto?: QueryAndSortDto, options?: any): AxiosPromise<Array<OrganisationScoredCompaniesDto>> {
            return localVarFp.extractScoredCompanies(queryAndSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extract Scored SmartGovernance Companies by Organisation
         * @param {QueryAndSortDto} [queryAndSortDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractScoredSmartGovernanceCompanies(queryAndSortDto?: QueryAndSortDto, options?: any): AxiosPromise<Array<OrganisationScoredCompaniesDto>> {
            return localVarFp.extractScoredSmartGovernanceCompanies(queryAndSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Scored Companies by Organisation Paginated
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScoredCompanies(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<OrganisationScoredCompaniesDtoQueryResultDto> {
            return localVarFp.listScoredCompanies(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationScoredCompaniesApi - object-oriented interface
 * @export
 * @class OrganisationScoredCompaniesApi
 * @extends {BaseAPI}
 */
export class OrganisationScoredCompaniesApi extends BaseAPI {
    /**
     * 
     * @summary Extract Scored Companies by Organisation
     * @param {QueryAndSortDto} [queryAndSortDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationScoredCompaniesApi
     */
    public extractScoredCompanies(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig) {
        return OrganisationScoredCompaniesApiFp(this.configuration).extractScoredCompanies(queryAndSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extract Scored SmartGovernance Companies by Organisation
     * @param {QueryAndSortDto} [queryAndSortDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationScoredCompaniesApi
     */
    public extractScoredSmartGovernanceCompanies(queryAndSortDto?: QueryAndSortDto, options?: AxiosRequestConfig) {
        return OrganisationScoredCompaniesApiFp(this.configuration).extractScoredSmartGovernanceCompanies(queryAndSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Scored Companies by Organisation Paginated
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationScoredCompaniesApi
     */
    public listScoredCompanies(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return OrganisationScoredCompaniesApiFp(this.configuration).listScoredCompanies(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationsApi - axios parameter creator
 * @export
 */
export const OrganisationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows an authorized administrator to add credits to an organisation
         * @summary Add credits to organisation
         * @param {string} organisationId 
         * @param {number} numberOfCreditsToAdd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCredits: async (organisationId: string, numberOfCreditsToAdd: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('addCredits', 'organisationId', organisationId)
            // verify required parameter 'numberOfCreditsToAdd' is not null or undefined
            assertParamExists('addCredits', 'numberOfCreditsToAdd', numberOfCreditsToAdd)
            const localVarPath = `/api/Organisations/{organisationId}/AddCredits/{numberOfCreditsToAdd}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"numberOfCreditsToAdd"}}`, encodeURIComponent(String(numberOfCreditsToAdd)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a organisation
         * @param {CreateOrganisationRequestDto} [createOrganisationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganisation: async (createOrganisationRequestDto?: CreateOrganisationRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organisations/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganisationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganisation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrganisation', 'id', id)
            const localVarPath = `/api/Organisations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOrganisation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disableOrganisation', 'id', id)
            const localVarPath = `/api/Organisations/{id}/Disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableOrganisation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableOrganisation', 'id', id)
            const localVarPath = `/api/Organisations/{id}/Enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retreives data relating to the credit consumption for an Organisation. 25 per page. Pages are zero-indexed
         * @summary Gets paged credit history for an Organisation
         * @param {string} organisationId 
         * @param {number} pageNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditHistory: async (organisationId: string, pageNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('getCreditHistory', 'organisationId', organisationId)
            // verify required parameter 'pageNumber' is not null or undefined
            assertParamExists('getCreditHistory', 'pageNumber', pageNumber)
            const localVarPath = `/api/Organisations/{organisationId}/GetCreditHistory/{pageNumber}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"pageNumber"}}`, encodeURIComponent(String(pageNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganisation', 'id', id)
            const localVarPath = `/api/Organisations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all organisations
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisations: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organisations/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows an authorized administrator to remove credits from an organisation
         * @summary Remove credits from organisation
         * @param {string} organisationId 
         * @param {number} numberOfCreditsToRemove 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCredits: async (organisationId: string, numberOfCreditsToRemove: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('removeCredits', 'organisationId', organisationId)
            // verify required parameter 'numberOfCreditsToRemove' is not null or undefined
            assertParamExists('removeCredits', 'numberOfCreditsToRemove', numberOfCreditsToRemove)
            const localVarPath = `/api/Organisations/{organisationId}/RemoveCredits/{numberOfCreditsToRemove}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"numberOfCreditsToRemove"}}`, encodeURIComponent(String(numberOfCreditsToRemove)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows an authorized administrator to set credits threshold for an organisation
         * @summary Set credits threshold for organisation
         * @param {string} organisationId 
         * @param {number} numberOfCredits 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCreditsThreshold: async (organisationId: string, numberOfCredits: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('setCreditsThreshold', 'organisationId', organisationId)
            // verify required parameter 'numberOfCredits' is not null or undefined
            assertParamExists('setCreditsThreshold', 'numberOfCredits', numberOfCredits)
            const localVarPath = `/api/Organisations/{organisationId}/SetCreditsThreshold/{numberOfCredits}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"numberOfCredits"}}`, encodeURIComponent(String(numberOfCredits)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a organisation
         * @param {string} id 
         * @param {UpdateOrganisationRequestDto} [updateOrganisationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisation: async (id: string, updateOrganisationRequestDto?: UpdateOrganisationRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganisation', 'id', id)
            const localVarPath = `/api/Organisations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganisationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationsApi - functional programming interface
 * @export
 */
export const OrganisationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows an authorized administrator to add credits to an organisation
         * @summary Add credits to organisation
         * @param {string} organisationId 
         * @param {number} numberOfCreditsToAdd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCredits(organisationId: string, numberOfCreditsToAdd: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCredits(organisationId, numberOfCreditsToAdd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a organisation
         * @param {CreateOrganisationRequestDto} [createOrganisationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganisation(createOrganisationRequestDto?: CreateOrganisationRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganisation(createOrganisationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganisation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganisation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableOrganisation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableOrganisation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableOrganisation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableOrganisation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retreives data relating to the credit consumption for an Organisation. 25 per page. Pages are zero-indexed
         * @summary Gets paged credit history for an Organisation
         * @param {string} organisationId 
         * @param {number} pageNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCreditHistory(organisationId: string, pageNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogCreditDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCreditHistory(organisationId, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganisation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve all organisations
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisations(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganisations(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows an authorized administrator to remove credits from an organisation
         * @summary Remove credits from organisation
         * @param {string} organisationId 
         * @param {number} numberOfCreditsToRemove 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCredits(organisationId: string, numberOfCreditsToRemove: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCredits(organisationId, numberOfCreditsToRemove, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows an authorized administrator to set credits threshold for an organisation
         * @summary Set credits threshold for organisation
         * @param {string} organisationId 
         * @param {number} numberOfCredits 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCreditsThreshold(organisationId: string, numberOfCredits: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCreditsThreshold(organisationId, numberOfCredits, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a organisation
         * @param {string} id 
         * @param {UpdateOrganisationRequestDto} [updateOrganisationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganisation(id: string, updateOrganisationRequestDto?: UpdateOrganisationRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganisation(id, updateOrganisationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationsApi - factory interface
 * @export
 */
export const OrganisationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationsApiFp(configuration)
    return {
        /**
         * Allows an authorized administrator to add credits to an organisation
         * @summary Add credits to organisation
         * @param {string} organisationId 
         * @param {number} numberOfCreditsToAdd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCredits(organisationId: string, numberOfCreditsToAdd: number, options?: any): AxiosPromise<void> {
            return localVarFp.addCredits(organisationId, numberOfCreditsToAdd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a organisation
         * @param {CreateOrganisationRequestDto} [createOrganisationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganisation(createOrganisationRequestDto?: CreateOrganisationRequestDto, options?: any): AxiosPromise<OrganisationDto> {
            return localVarFp.createOrganisation(createOrganisationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganisation(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteOrganisation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOrganisation(id: string, options?: any): AxiosPromise<OrganisationDto> {
            return localVarFp.disableOrganisation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableOrganisation(id: string, options?: any): AxiosPromise<OrganisationDto> {
            return localVarFp.enableOrganisation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retreives data relating to the credit consumption for an Organisation. 25 per page. Pages are zero-indexed
         * @summary Gets paged credit history for an Organisation
         * @param {string} organisationId 
         * @param {number} pageNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditHistory(organisationId: string, pageNumber: number, options?: any): AxiosPromise<AuditLogCreditDtoQueryResultDto> {
            return localVarFp.getCreditHistory(organisationId, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a organisation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisation(id: string, options?: any): AxiosPromise<OrganisationDto> {
            return localVarFp.getOrganisation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all organisations
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisations(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<OrganisationDtoQueryResultDto> {
            return localVarFp.getOrganisations(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows an authorized administrator to remove credits from an organisation
         * @summary Remove credits from organisation
         * @param {string} organisationId 
         * @param {number} numberOfCreditsToRemove 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCredits(organisationId: string, numberOfCreditsToRemove: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeCredits(organisationId, numberOfCreditsToRemove, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows an authorized administrator to set credits threshold for an organisation
         * @summary Set credits threshold for organisation
         * @param {string} organisationId 
         * @param {number} numberOfCredits 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCreditsThreshold(organisationId: string, numberOfCredits: number, options?: any): AxiosPromise<void> {
            return localVarFp.setCreditsThreshold(organisationId, numberOfCredits, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a organisation
         * @param {string} id 
         * @param {UpdateOrganisationRequestDto} [updateOrganisationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisation(id: string, updateOrganisationRequestDto?: UpdateOrganisationRequestDto, options?: any): AxiosPromise<OrganisationDto> {
            return localVarFp.updateOrganisation(id, updateOrganisationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationsApi - object-oriented interface
 * @export
 * @class OrganisationsApi
 * @extends {BaseAPI}
 */
export class OrganisationsApi extends BaseAPI {
    /**
     * Allows an authorized administrator to add credits to an organisation
     * @summary Add credits to organisation
     * @param {string} organisationId 
     * @param {number} numberOfCreditsToAdd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public addCredits(organisationId: string, numberOfCreditsToAdd: number, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).addCredits(organisationId, numberOfCreditsToAdd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a organisation
     * @param {CreateOrganisationRequestDto} [createOrganisationRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public createOrganisation(createOrganisationRequestDto?: CreateOrganisationRequestDto, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).createOrganisation(createOrganisationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a organisation
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public deleteOrganisation(id: string, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).deleteOrganisation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable a organisation
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public disableOrganisation(id: string, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).disableOrganisation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable a organisation
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public enableOrganisation(id: string, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).enableOrganisation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retreives data relating to the credit consumption for an Organisation. 25 per page. Pages are zero-indexed
     * @summary Gets paged credit history for an Organisation
     * @param {string} organisationId 
     * @param {number} pageNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public getCreditHistory(organisationId: string, pageNumber: number, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).getCreditHistory(organisationId, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a organisation
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public getOrganisation(id: string, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).getOrganisation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all organisations
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public getOrganisations(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).getOrganisations(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows an authorized administrator to remove credits from an organisation
     * @summary Remove credits from organisation
     * @param {string} organisationId 
     * @param {number} numberOfCreditsToRemove 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public removeCredits(organisationId: string, numberOfCreditsToRemove: number, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).removeCredits(organisationId, numberOfCreditsToRemove, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows an authorized administrator to set credits threshold for an organisation
     * @summary Set credits threshold for organisation
     * @param {string} organisationId 
     * @param {number} numberOfCredits 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public setCreditsThreshold(organisationId: string, numberOfCredits: number, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).setCreditsThreshold(organisationId, numberOfCredits, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a organisation
     * @param {string} id 
     * @param {UpdateOrganisationRequestDto} [updateOrganisationRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    public updateOrganisation(id: string, updateOrganisationRequestDto?: UpdateOrganisationRequestDto, options?: AxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).updateOrganisation(id, updateOrganisationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuestionnaireApi - axios parameter creator
 * @export
 */
export const QuestionnaireApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if a question response is valid
         * @param {string} alias 
         * @param {CheckQuestionResponseDto} [checkQuestionResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResponse: async (alias: string, checkQuestionResponseDto?: CheckQuestionResponseDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('checkResponse', 'alias', alias)
            const localVarPath = `/api/Questionnaire/Section/{alias}/Check`
                .replace(`{${"alias"}}`, encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkQuestionResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update a user\'s section response
         * @param {string} alias 
         * @param {boolean} [updateScore] 
         * @param {boolean} [markInformationSeen] 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateResponse: async (alias: string, updateScore?: boolean, markInformationSeen?: boolean, sectionUpdateDto?: SectionUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('createOrUpdateResponse', 'alias', alias)
            const localVarPath = `/api/Questionnaire/Section/{alias}/Response`
                .replace(`{${"alias"}}`, encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateScore !== undefined) {
                localVarQueryParameter['updateScore'] = updateScore;
            }

            if (markInformationSeen !== undefined) {
                localVarQueryParameter['markInformationSeen'] = markInformationSeen;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sectionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single file for a question
         * @param {string} sectionAlias 
         * @param {string} fileResponseId 
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (sectionAlias: string, fileResponseId: string, companyId?: string, dealId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionAlias' is not null or undefined
            assertParamExists('deleteFile', 'sectionAlias', sectionAlias)
            // verify required parameter 'fileResponseId' is not null or undefined
            assertParamExists('deleteFile', 'fileResponseId', fileResponseId)
            const localVarPath = `/api/Questionnaire/File`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (dealId !== undefined) {
                localVarQueryParameter['dealId'] = dealId;
            }

            if (sectionAlias !== undefined) {
                localVarQueryParameter['sectionAlias'] = sectionAlias;
            }

            if (fileResponseId !== undefined) {
                localVarQueryParameter['fileResponseId'] = fileResponseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a sub-section response
         * @param {string} sectionAlias 
         * @param {string} subSectionResponseId 
         * @param {string} alias 
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubSectionResponse: async (sectionAlias: string, subSectionResponseId: string, alias: string, companyId?: string, dealId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionAlias' is not null or undefined
            assertParamExists('deleteSubSectionResponse', 'sectionAlias', sectionAlias)
            // verify required parameter 'subSectionResponseId' is not null or undefined
            assertParamExists('deleteSubSectionResponse', 'subSectionResponseId', subSectionResponseId)
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('deleteSubSectionResponse', 'alias', alias)
            const localVarPath = `/api/Questionnaire/Section/{alias}/Response`
                .replace(`{${"alias"}}`, encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (dealId !== undefined) {
                localVarQueryParameter['dealId'] = dealId;
            }

            if (sectionAlias !== undefined) {
                localVarQueryParameter['sectionAlias'] = sectionAlias;
            }

            if (subSectionResponseId !== undefined) {
                localVarQueryParameter['subSectionResponseId'] = subSectionResponseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of questionnaire sections, including state information for the user\'s current response for each section.
         * @summary Retrieve all questionnaires sections
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSections: async (companyId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Questionnaire/Section/All`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch file by file url
         * @summary Fetch file by file url
         * @param {string} [filePrivateUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilePublicUrl: async (filePrivateUrl?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Questionnaire/File/GetPublicUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filePrivateUrl !== undefined) {
                localVarQueryParameter['filePrivateUrl'] = filePrivateUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of options based on given query string
         * @summary Autocomplete for option set by alias
         * @param {string} alias Option set alias
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: async (alias: string, query?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('getOptions', 'alias', alias)
            const localVarPath = `/api/Questionnaire/OptionSet/{alias}`
                .replace(`{${"alias"}}`, encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Section will include the user\'s current responses if a section response exists.
         * @summary Retrieve questionnaire section by alias
         * @param {string} alias Section alias
         * @param {string} [companyId] Company ID
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSection: async (alias: string, companyId?: string, dealId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('getSection', 'alias', alias)
            const localVarPath = `/api/Questionnaire/Section/{alias}`
                .replace(`{${"alias"}}`, encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (dealId !== undefined) {
                localVarQueryParameter['dealId'] = dealId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get unsatisfiedSections
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnsatisfiedSections: async (companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getUnsatisfiedSections', 'companyId', companyId)
            const localVarPath = `/api/Questionnaire/GetUnsatisfiedSections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm and submit Wome Company Application
         * @param {string} alias 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWomeCompany: async (alias: string, sectionUpdateDto?: SectionUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('submitWomeCompany', 'alias', alias)
            const localVarPath = `/api/Questionnaire/Section/{alias}/SubmitWomeCompany`
                .replace(`{${"alias"}}`, encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sectionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm and update SG score response
         * @param {string} alias 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSmartGovernanceScore: async (alias: string, sectionUpdateDto?: SectionUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('updateSmartGovernanceScore', 'alias', alias)
            const localVarPath = `/api/Questionnaire/Section/{alias}/UpdateSmartGovernanceScore`
                .replace(`{${"alias"}}`, encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sectionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update request must include only a single file response
         * @summary Upload a single file for a question
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (sectionUpdateDto?: SectionUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Questionnaire/File`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sectionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnaireApi - functional programming interface
 * @export
 */
export const QuestionnaireApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnaireApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check if a question response is valid
         * @param {string} alias 
         * @param {CheckQuestionResponseDto} [checkQuestionResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkResponse(alias: string, checkQuestionResponseDto?: CheckQuestionResponseDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkResponse(alias, checkQuestionResponseDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create or update a user\'s section response
         * @param {string} alias 
         * @param {boolean} [updateScore] 
         * @param {boolean} [markInformationSeen] 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateResponse(alias: string, updateScore?: boolean, markInformationSeen?: boolean, sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionResponseUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateResponse(alias, updateScore, markInformationSeen, sectionUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single file for a question
         * @param {string} sectionAlias 
         * @param {string} fileResponseId 
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(sectionAlias: string, fileResponseId: string, companyId?: string, dealId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionResponseUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(sectionAlias, fileResponseId, companyId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a sub-section response
         * @param {string} sectionAlias 
         * @param {string} subSectionResponseId 
         * @param {string} alias 
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubSectionResponse(sectionAlias: string, subSectionResponseId: string, alias: string, companyId?: string, dealId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionResponseUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubSectionResponse(sectionAlias, subSectionResponseId, alias, companyId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns list of questionnaire sections, including state information for the user\'s current response for each section.
         * @summary Retrieve all questionnaires sections
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSections(companyId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionStubDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSections(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch file by file url
         * @summary Fetch file by file url
         * @param {string} [filePrivateUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilePublicUrl(filePrivateUrl?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilePublicUrl(filePrivateUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of options based on given query string
         * @summary Autocomplete for option set by alias
         * @param {string} alias Option set alias
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOptions(alias: string, query?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOptions(alias, query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Section will include the user\'s current responses if a section response exists.
         * @summary Retrieve questionnaire section by alias
         * @param {string} alias Section alias
         * @param {string} [companyId] Company ID
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSection(alias: string, companyId?: string, dealId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSection(alias, companyId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get unsatisfiedSections
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnsatisfiedSections(companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnsatisfiedSections(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirm and submit Wome Company Application
         * @param {string} alias 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitWomeCompany(alias: string, sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionResponseUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitWomeCompany(alias, sectionUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirm and update SG score response
         * @param {string} alias 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSmartGovernanceScore(alias: string, sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionResponseUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSmartGovernanceScore(alias, sectionUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update request must include only a single file response
         * @summary Upload a single file for a question
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionResponseUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(sectionUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuestionnaireApi - factory interface
 * @export
 */
export const QuestionnaireApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnaireApiFp(configuration)
    return {
        /**
         * 
         * @summary Check if a question response is valid
         * @param {string} alias 
         * @param {CheckQuestionResponseDto} [checkQuestionResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResponse(alias: string, checkQuestionResponseDto?: CheckQuestionResponseDto, options?: any): AxiosPromise<void> {
            return localVarFp.checkResponse(alias, checkQuestionResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update a user\'s section response
         * @param {string} alias 
         * @param {boolean} [updateScore] 
         * @param {boolean} [markInformationSeen] 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateResponse(alias: string, updateScore?: boolean, markInformationSeen?: boolean, sectionUpdateDto?: SectionUpdateDto, options?: any): AxiosPromise<SectionResponseUpdatedDto> {
            return localVarFp.createOrUpdateResponse(alias, updateScore, markInformationSeen, sectionUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single file for a question
         * @param {string} sectionAlias 
         * @param {string} fileResponseId 
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(sectionAlias: string, fileResponseId: string, companyId?: string, dealId?: string, options?: any): AxiosPromise<SectionResponseUpdatedDto> {
            return localVarFp.deleteFile(sectionAlias, fileResponseId, companyId, dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a sub-section response
         * @param {string} sectionAlias 
         * @param {string} subSectionResponseId 
         * @param {string} alias 
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubSectionResponse(sectionAlias: string, subSectionResponseId: string, alias: string, companyId?: string, dealId?: string, options?: any): AxiosPromise<SectionResponseUpdatedDto> {
            return localVarFp.deleteSubSectionResponse(sectionAlias, subSectionResponseId, alias, companyId, dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of questionnaire sections, including state information for the user\'s current response for each section.
         * @summary Retrieve all questionnaires sections
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSections(companyId?: string, options?: any): AxiosPromise<Array<SectionStubDto>> {
            return localVarFp.getAllSections(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch file by file url
         * @summary Fetch file by file url
         * @param {string} [filePrivateUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilePublicUrl(filePrivateUrl?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFilePublicUrl(filePrivateUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of options based on given query string
         * @summary Autocomplete for option set by alias
         * @param {string} alias Option set alias
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions(alias: string, query?: string, options?: any): AxiosPromise<Array<OptionDto>> {
            return localVarFp.getOptions(alias, query, options).then((request) => request(axios, basePath));
        },
        /**
         * Section will include the user\'s current responses if a section response exists.
         * @summary Retrieve questionnaire section by alias
         * @param {string} alias Section alias
         * @param {string} [companyId] Company ID
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSection(alias: string, companyId?: string, dealId?: string, options?: any): AxiosPromise<SectionDto> {
            return localVarFp.getSection(alias, companyId, dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get unsatisfiedSections
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnsatisfiedSections(companyId: string, options?: any): AxiosPromise<Array<SectionDto>> {
            return localVarFp.getUnsatisfiedSections(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm and submit Wome Company Application
         * @param {string} alias 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWomeCompany(alias: string, sectionUpdateDto?: SectionUpdateDto, options?: any): AxiosPromise<SectionResponseUpdatedDto> {
            return localVarFp.submitWomeCompany(alias, sectionUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm and update SG score response
         * @param {string} alias 
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSmartGovernanceScore(alias: string, sectionUpdateDto?: SectionUpdateDto, options?: any): AxiosPromise<SectionResponseUpdatedDto> {
            return localVarFp.updateSmartGovernanceScore(alias, sectionUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update request must include only a single file response
         * @summary Upload a single file for a question
         * @param {SectionUpdateDto} [sectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(sectionUpdateDto?: SectionUpdateDto, options?: any): AxiosPromise<SectionResponseUpdatedDto> {
            return localVarFp.uploadFile(sectionUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionnaireApi - object-oriented interface
 * @export
 * @class QuestionnaireApi
 * @extends {BaseAPI}
 */
export class QuestionnaireApi extends BaseAPI {
    /**
     * 
     * @summary Check if a question response is valid
     * @param {string} alias 
     * @param {CheckQuestionResponseDto} [checkQuestionResponseDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public checkResponse(alias: string, checkQuestionResponseDto?: CheckQuestionResponseDto, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).checkResponse(alias, checkQuestionResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update a user\'s section response
     * @param {string} alias 
     * @param {boolean} [updateScore] 
     * @param {boolean} [markInformationSeen] 
     * @param {SectionUpdateDto} [sectionUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public createOrUpdateResponse(alias: string, updateScore?: boolean, markInformationSeen?: boolean, sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).createOrUpdateResponse(alias, updateScore, markInformationSeen, sectionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single file for a question
     * @param {string} sectionAlias 
     * @param {string} fileResponseId 
     * @param {string} [companyId] 
     * @param {string} [dealId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public deleteFile(sectionAlias: string, fileResponseId: string, companyId?: string, dealId?: string, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).deleteFile(sectionAlias, fileResponseId, companyId, dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a sub-section response
     * @param {string} sectionAlias 
     * @param {string} subSectionResponseId 
     * @param {string} alias 
     * @param {string} [companyId] 
     * @param {string} [dealId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public deleteSubSectionResponse(sectionAlias: string, subSectionResponseId: string, alias: string, companyId?: string, dealId?: string, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).deleteSubSectionResponse(sectionAlias, subSectionResponseId, alias, companyId, dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of questionnaire sections, including state information for the user\'s current response for each section.
     * @summary Retrieve all questionnaires sections
     * @param {string} [companyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public getAllSections(companyId?: string, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).getAllSections(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch file by file url
     * @summary Fetch file by file url
     * @param {string} [filePrivateUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public getFilePublicUrl(filePrivateUrl?: string, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).getFilePublicUrl(filePrivateUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of options based on given query string
     * @summary Autocomplete for option set by alias
     * @param {string} alias Option set alias
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public getOptions(alias: string, query?: string, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).getOptions(alias, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Section will include the user\'s current responses if a section response exists.
     * @summary Retrieve questionnaire section by alias
     * @param {string} alias Section alias
     * @param {string} [companyId] Company ID
     * @param {string} [dealId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public getSection(alias: string, companyId?: string, dealId?: string, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).getSection(alias, companyId, dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get unsatisfiedSections
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public getUnsatisfiedSections(companyId: string, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).getUnsatisfiedSections(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm and submit Wome Company Application
     * @param {string} alias 
     * @param {SectionUpdateDto} [sectionUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public submitWomeCompany(alias: string, sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).submitWomeCompany(alias, sectionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm and update SG score response
     * @param {string} alias 
     * @param {SectionUpdateDto} [sectionUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public updateSmartGovernanceScore(alias: string, sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).updateSmartGovernanceScore(alias, sectionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update request must include only a single file response
     * @summary Upload a single file for a question
     * @param {SectionUpdateDto} [sectionUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public uploadFile(sectionUpdateDto?: SectionUpdateDto, options?: AxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).uploadFile(sectionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ScoreApi - axios parameter creator
 * @export
 */
export const ScoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets a score for an entity. Submit only a companyId to get the score for that company. Submit both a deal and company to score a deal. companyId must have a value
         * @summary Retrieve company score summary
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (companyId?: string, dealId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Score/Score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (dealId !== undefined) {
                localVarQueryParameter['dealId'] = dealId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark scoring information as seen
         * @param {string} [companyId] 
         * @param {Array<string>} [informationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInformationSeen: async (companyId?: string, informationIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Score/Information/Seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (informationIds) {
                localVarQueryParameter['informationIds'] = informationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoreApi - functional programming interface
 * @export
 */
export const ScoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScoreApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets a score for an entity. Submit only a companyId to get the score for that company. Submit both a deal and company to score a deal. companyId must have a value
         * @summary Retrieve company score summary
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(companyId?: string, dealId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityScoreSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(companyId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark scoring information as seen
         * @param {string} [companyId] 
         * @param {Array<string>} [informationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInformationSeen(companyId?: string, informationIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInformationSeen(companyId, informationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScoreApi - factory interface
 * @export
 */
export const ScoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScoreApiFp(configuration)
    return {
        /**
         * Gets a score for an entity. Submit only a companyId to get the score for that company. Submit both a deal and company to score a deal. companyId must have a value
         * @summary Retrieve company score summary
         * @param {string} [companyId] 
         * @param {string} [dealId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(companyId?: string, dealId?: string, options?: any): AxiosPromise<EntityScoreSummaryDto> {
            return localVarFp.get(companyId, dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark scoring information as seen
         * @param {string} [companyId] 
         * @param {Array<string>} [informationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInformationSeen(companyId?: string, informationIds?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.markInformationSeen(companyId, informationIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScoreApi - object-oriented interface
 * @export
 * @class ScoreApi
 * @extends {BaseAPI}
 */
export class ScoreApi extends BaseAPI {
    /**
     * Gets a score for an entity. Submit only a companyId to get the score for that company. Submit both a deal and company to score a deal. companyId must have a value
     * @summary Retrieve company score summary
     * @param {string} [companyId] 
     * @param {string} [dealId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public get(companyId?: string, dealId?: string, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).get(companyId, dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark scoring information as seen
     * @param {string} [companyId] 
     * @param {Array<string>} [informationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public markInformationSeen(companyId?: string, informationIds?: Array<string>, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).markInformationSeen(companyId, informationIds, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SectorCodesApi - axios parameter creator
 * @export
 */
export const SectorCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of Sector codes (with a criteria score) that match the given euSectorName or codes.
         * @summary Get sector criteria scores
         * @param {string} [euSectorName] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorCriteria: async (euSectorName?: string, ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SectorCodes/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (euSectorName !== undefined) {
                localVarQueryParameter['euSectorName'] = euSectorName;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of Sector codes that match the given query string or codes.
         * @summary Search Sector codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSector: async (query?: string, ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SectorCodes/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SectorCodesApi - functional programming interface
 * @export
 */
export const SectorCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SectorCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of Sector codes (with a criteria score) that match the given euSectorName or codes.
         * @summary Get sector criteria scores
         * @param {string} [euSectorName] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSectorCriteria(euSectorName?: string, ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectorCodeWithCriteriaScoreDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSectorCriteria(euSectorName, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of Sector codes that match the given query string or codes.
         * @summary Search Sector codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSector(query?: string, ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectorCodeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSector(query, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SectorCodesApi - factory interface
 * @export
 */
export const SectorCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SectorCodesApiFp(configuration)
    return {
        /**
         * Returns a list of Sector codes (with a criteria score) that match the given euSectorName or codes.
         * @summary Get sector criteria scores
         * @param {string} [euSectorName] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorCriteria(euSectorName?: string, ids?: Array<string>, options?: any): AxiosPromise<Array<SectorCodeWithCriteriaScoreDto>> {
            return localVarFp.getSectorCriteria(euSectorName, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of Sector codes that match the given query string or codes.
         * @summary Search Sector codes by query string or list of codes
         * @param {string} [query] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSector(query?: string, ids?: Array<string>, options?: any): AxiosPromise<Array<SectorCodeDto>> {
            return localVarFp.searchSector(query, ids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SectorCodesApi - object-oriented interface
 * @export
 * @class SectorCodesApi
 * @extends {BaseAPI}
 */
export class SectorCodesApi extends BaseAPI {
    /**
     * Returns a list of Sector codes (with a criteria score) that match the given euSectorName or codes.
     * @summary Get sector criteria scores
     * @param {string} [euSectorName] 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectorCodesApi
     */
    public getSectorCriteria(euSectorName?: string, ids?: Array<string>, options?: AxiosRequestConfig) {
        return SectorCodesApiFp(this.configuration).getSectorCriteria(euSectorName, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of Sector codes that match the given query string or codes.
     * @summary Search Sector codes by query string or list of codes
     * @param {string} [query] 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectorCodesApi
     */
    public searchSector(query?: string, ids?: Array<string>, options?: AxiosRequestConfig) {
        return SectorCodesApiFp(this.configuration).searchSector(query, ids, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemTestApi - axios parameter creator
 * @export
 */
export const SystemTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Tests the exception code.
         * @summary Tests the exception code
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testException: async (key?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemTest/TestException`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemTestApi - functional programming interface
 * @export
 */
export const SystemTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemTestApiAxiosParamCreator(configuration)
    return {
        /**
         * Tests the exception code.
         * @summary Tests the exception code
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testException(key?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testException(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemTestApi - factory interface
 * @export
 */
export const SystemTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemTestApiFp(configuration)
    return {
        /**
         * Tests the exception code.
         * @summary Tests the exception code
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testException(key?: string, options?: any): AxiosPromise<string> {
            return localVarFp.testException(key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemTestApi - object-oriented interface
 * @export
 * @class SystemTestApi
 * @extends {BaseAPI}
 */
export class SystemTestApi extends BaseAPI {
    /**
     * Tests the exception code.
     * @summary Tests the exception code
     * @param {string} [key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemTestApi
     */
    public testException(key?: string, options?: AxiosRequestConfig) {
        return SystemTestApiFp(this.configuration).testException(key, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TempTasksApi - axios parameter creator
 * @export
 */
export const TempTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ExecuteTempTask
         * @param {TempTaskRequestDto} [tempTaskRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTempTask: async (tempTaskRequestDto?: TempTaskRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TempTasks/ExecuteTempTask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tempTaskRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all temp tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempTasks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TempTasks/GetTempTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TempTasksApi - functional programming interface
 * @export
 */
export const TempTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TempTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ExecuteTempTask
         * @param {TempTaskRequestDto} [tempTaskRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeTempTask(tempTaskRequestDto?: TempTaskRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeTempTask(tempTaskRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all temp tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTempTasks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TempTaskFuncDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTempTasks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TempTasksApi - factory interface
 * @export
 */
export const TempTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TempTasksApiFp(configuration)
    return {
        /**
         * 
         * @summary ExecuteTempTask
         * @param {TempTaskRequestDto} [tempTaskRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTempTask(tempTaskRequestDto?: TempTaskRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.executeTempTask(tempTaskRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all temp tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempTasks(options?: any): AxiosPromise<Array<TempTaskFuncDto>> {
            return localVarFp.getTempTasks(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TempTasksApi - object-oriented interface
 * @export
 * @class TempTasksApi
 * @extends {BaseAPI}
 */
export class TempTasksApi extends BaseAPI {
    /**
     * 
     * @summary ExecuteTempTask
     * @param {TempTaskRequestDto} [tempTaskRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempTasksApi
     */
    public executeTempTask(tempTaskRequestDto?: TempTaskRequestDto, options?: AxiosRequestConfig) {
        return TempTasksApiFp(this.configuration).executeTempTask(tempTaskRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all temp tasks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempTasksApi
     */
    public getTempTasks(options?: AxiosRequestConfig) {
        return TempTasksApiFp(this.configuration).getTempTasks(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an Transaction record
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransaction: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTransaction', 'id', id)
            const localVarPath = `/api/Transaction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all scored transactions by an organisation
         * @summary Get all scored transactions by an organisation
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTransactionScores: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/GetAllTransactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns transaction by an organisation
         * @summary Get transaction detail
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetail: async (transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getTransactionDetail', 'transactionId', transactionId)
            const localVarPath = `/api/Transaction/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns score of a particular transaction
         * @summary Get transaction score by transactionId
         * @param {string} transactionId 
         * @param {TransactionReportTypeDto} [output] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionReport: async (transactionId: string, output?: TransactionReportTypeDto, debug?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getTransactionReport', 'transactionId', transactionId)
            const localVarPath = `/api/Transaction/Score/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (output !== undefined) {
                localVarQueryParameter['output'] = output;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns score of a particular transaction
         * @summary Create a transaction for scoring
         * @param {TransactionScoringRequestDto} [transactionScoringRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreNewTransaction: async (transactionScoringRequestDto?: TransactionScoringRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/Score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionScoringRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an Transaction record
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTransaction(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTransaction(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all scored transactions by an organisation
         * @summary Get all scored transactions by an organisation
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTransactionScores(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTransactionScores(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns transaction by an organisation
         * @summary Get transaction detail
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionDetail(transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionDetail(transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns score of a particular transaction
         * @summary Get transaction score by transactionId
         * @param {string} transactionId 
         * @param {TransactionReportTypeDto} [output] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionReport(transactionId: string, output?: TransactionReportTypeDto, debug?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionReport(transactionId, output, debug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns score of a particular transaction
         * @summary Create a transaction for scoring
         * @param {TransactionScoringRequestDto} [transactionScoringRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreNewTransaction(transactionScoringRequestDto?: TransactionScoringRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionScoringResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreNewTransaction(transactionScoringRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an Transaction record
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransaction(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTransaction(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all scored transactions by an organisation
         * @summary Get all scored transactions by an organisation
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTransactionScores(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<TransactionDtoQueryResultDto> {
            return localVarFp.getAllTransactionScores(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns transaction by an organisation
         * @summary Get transaction detail
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetail(transactionId: string, options?: any): AxiosPromise<TransactionDto> {
            return localVarFp.getTransactionDetail(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns score of a particular transaction
         * @summary Get transaction score by transactionId
         * @param {string} transactionId 
         * @param {TransactionReportTypeDto} [output] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionReport(transactionId: string, output?: TransactionReportTypeDto, debug?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.getTransactionReport(transactionId, output, debug, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns score of a particular transaction
         * @summary Create a transaction for scoring
         * @param {TransactionScoringRequestDto} [transactionScoringRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreNewTransaction(transactionScoringRequestDto?: TransactionScoringRequestDto, options?: any): AxiosPromise<TransactionScoringResponseDto> {
            return localVarFp.scoreNewTransaction(transactionScoringRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI {
    /**
     * 
     * @summary Delete an Transaction record
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public deleteTransaction(id: string, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).deleteTransaction(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all scored transactions by an organisation
     * @summary Get all scored transactions by an organisation
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public getAllTransactionScores(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).getAllTransactionScores(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns transaction by an organisation
     * @summary Get transaction detail
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public getTransactionDetail(transactionId: string, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).getTransactionDetail(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns score of a particular transaction
     * @summary Get transaction score by transactionId
     * @param {string} transactionId 
     * @param {TransactionReportTypeDto} [output] 
     * @param {boolean} [debug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public getTransactionReport(transactionId: string, output?: TransactionReportTypeDto, debug?: boolean, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).getTransactionReport(transactionId, output, debug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns score of a particular transaction
     * @summary Create a transaction for scoring
     * @param {TransactionScoringRequestDto} [transactionScoringRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public scoreNewTransaction(transactionScoringRequestDto?: TransactionScoringRequestDto, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).scoreNewTransaction(transactionScoringRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Give service permission to manage company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectToService: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/ConnectToService`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an user with role
         * @param {CreateUserRequestDto} [createUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserRequestDto?: CreateUserRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable a tfp user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTfpUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disableTfpUser', 'id', id)
            const localVarPath = `/api/User/{id}/Disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable a tfp user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableTfpUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableTfpUser', 'id', id)
            const localVarPath = `/api/User/{id}/Enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/Current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the company with score information owned by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCompany: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/CurrentCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current organisation of the login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganisation: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/CurrentOrganisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Resources that a role has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/GetResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a user
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id)
            const localVarPath = `/api/User/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complex query all users
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/GetUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change user attributes, currently only organisationId and role are allowed
         * @summary Update User
         * @param {string} id 
         * @param {UpdateUserRequestDto} [updateUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: string, updateUserRequestDto?: UpdateUserRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            const localVarPath = `/api/User/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Give service permission to manage company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectToService(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectToService(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create an user with role
         * @param {CreateUserRequestDto} [createUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserRequestDto?: CreateUserRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable a tfp user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableTfpUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableTfpUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable a tfp user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableTfpUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableTfpUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrent(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve the company with score information owned by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCompany(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCompany(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve the current organisation of the login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentOrganisation(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentOrganisation(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Resources that a role has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResource(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EPolicy>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResource(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a user
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Complex query all users
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Change user attributes, currently only organisationId and role are allowed
         * @summary Update User
         * @param {string} id 
         * @param {UpdateUserRequestDto} [updateUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: string, updateUserRequestDto?: UpdateUserRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, updateUserRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Give service permission to manage company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectToService(options?: any): AxiosPromise<void> {
            return localVarFp.connectToService(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an user with role
         * @param {CreateUserRequestDto} [createUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserRequestDto?: CreateUserRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.createUser(createUserRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable a tfp user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTfpUser(id: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.disableTfpUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable a tfp user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableTfpUser(id: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.enableTfpUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrent(options?: any): AxiosPromise<CurrentUserDto> {
            return localVarFp.getCurrent(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the company with score information owned by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCompany(options?: any): AxiosPromise<CompanyDetailedDto> {
            return localVarFp.getCurrentCompany(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current organisation of the login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganisation(options?: any): AxiosPromise<OrganisationDto> {
            return localVarFp.getCurrentOrganisation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Resources that a role has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource(options?: any): AxiosPromise<Array<EPolicy>> {
            return localVarFp.getResource(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a user
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.getUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complex query all users
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<UserDtoQueryResultDto> {
            return localVarFp.getUsers(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Change user attributes, currently only organisationId and role are allowed
         * @summary Update User
         * @param {string} id 
         * @param {UpdateUserRequestDto} [updateUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: string, updateUserRequestDto?: UpdateUserRequestDto, options?: any): AxiosPromise<UserDto> {
            return localVarFp.updateUser(id, updateUserRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Give service permission to manage company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public connectToService(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).connectToService(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an user with role
     * @param {CreateUserRequestDto} [createUserRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createUser(createUserRequestDto?: CreateUserRequestDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).createUser(createUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable a tfp user account
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public disableTfpUser(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).disableTfpUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable a tfp user account
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public enableTfpUser(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).enableTfpUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrent(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the company with score information owned by the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentCompany(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrentCompany(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current organisation of the login user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentOrganisation(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrentOrganisation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Resources that a role has access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getResource(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getResource(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a user
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUser(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complex query all users
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUsers(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUsers(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change user attributes, currently only organisationId and role are allowed
     * @summary Update User
     * @param {string} id 
     * @param {UpdateUserRequestDto} [updateUserRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUser(id: string, updateUserRequestDto?: UpdateUserRequestDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUser(id, updateUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WomeApplicationsApi - axios parameter creator
 * @export
 */
export const WomeApplicationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve an wome application
         * @param {string} id 
         * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveWomeApplication: async (id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveWomeApplication', 'id', id)
            const localVarPath = `/api/WomeApplications/{id}/Approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(womeApplicationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a SG assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWomeApplication: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WomeApplications/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an wome application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWomeApplication: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWomeApplication', 'id', id)
            const localVarPath = `/api/WomeApplications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all organisation wome applications
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWomeApplications: async (queryAndCountDto?: QueryAndCountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WomeApplications/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryAndCountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an wome application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWomeApplication: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWomeApplication', 'id', id)
            const localVarPath = `/api/WomeApplications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject an wome application
         * @param {string} id 
         * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectWomeApplication: async (id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectWomeApplication', 'id', id)
            const localVarPath = `/api/WomeApplications/{id}/Reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(womeApplicationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WomeApplicationsApi - functional programming interface
 * @export
 */
export const WomeApplicationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WomeApplicationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve an wome application
         * @param {string} id 
         * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveWomeApplication(id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WomeApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveWomeApplication(id, womeApplicationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a SG assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWomeApplication(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WomeApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWomeApplication(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an wome application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWomeApplication(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWomeApplication(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve all organisation wome applications
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWomeApplications(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WomeApplicationDtoQueryResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllWomeApplications(queryAndCountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an wome application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWomeApplication(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WomeApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWomeApplication(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject an wome application
         * @param {string} id 
         * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectWomeApplication(id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WomeApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectWomeApplication(id, womeApplicationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WomeApplicationsApi - factory interface
 * @export
 */
export const WomeApplicationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WomeApplicationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve an wome application
         * @param {string} id 
         * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveWomeApplication(id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options?: any): AxiosPromise<WomeApplicationDto> {
            return localVarFp.approveWomeApplication(id, womeApplicationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a SG assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWomeApplication(options?: any): AxiosPromise<WomeApplicationDto> {
            return localVarFp.createWomeApplication(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an wome application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWomeApplication(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWomeApplication(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all organisation wome applications
         * @param {QueryAndCountDto} [queryAndCountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWomeApplications(queryAndCountDto?: QueryAndCountDto, options?: any): AxiosPromise<WomeApplicationDtoQueryResultDto> {
            return localVarFp.getAllWomeApplications(queryAndCountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an wome application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWomeApplication(id: string, options?: any): AxiosPromise<WomeApplicationDto> {
            return localVarFp.getWomeApplication(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject an wome application
         * @param {string} id 
         * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectWomeApplication(id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options?: any): AxiosPromise<WomeApplicationDto> {
            return localVarFp.rejectWomeApplication(id, womeApplicationUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WomeApplicationsApi - object-oriented interface
 * @export
 * @class WomeApplicationsApi
 * @extends {BaseAPI}
 */
export class WomeApplicationsApi extends BaseAPI {
    /**
     * 
     * @summary Approve an wome application
     * @param {string} id 
     * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WomeApplicationsApi
     */
    public approveWomeApplication(id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options?: AxiosRequestConfig) {
        return WomeApplicationsApiFp(this.configuration).approveWomeApplication(id, womeApplicationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a SG assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WomeApplicationsApi
     */
    public createWomeApplication(options?: AxiosRequestConfig) {
        return WomeApplicationsApiFp(this.configuration).createWomeApplication(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an wome application
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WomeApplicationsApi
     */
    public deleteWomeApplication(id: string, options?: AxiosRequestConfig) {
        return WomeApplicationsApiFp(this.configuration).deleteWomeApplication(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all organisation wome applications
     * @param {QueryAndCountDto} [queryAndCountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WomeApplicationsApi
     */
    public getAllWomeApplications(queryAndCountDto?: QueryAndCountDto, options?: AxiosRequestConfig) {
        return WomeApplicationsApiFp(this.configuration).getAllWomeApplications(queryAndCountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an wome application
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WomeApplicationsApi
     */
    public getWomeApplication(id: string, options?: AxiosRequestConfig) {
        return WomeApplicationsApiFp(this.configuration).getWomeApplication(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject an wome application
     * @param {string} id 
     * @param {WomeApplicationUpdateDto} [womeApplicationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WomeApplicationsApi
     */
    public rejectWomeApplication(id: string, womeApplicationUpdateDto?: WomeApplicationUpdateDto, options?: AxiosRequestConfig) {
        return WomeApplicationsApiFp(this.configuration).rejectWomeApplication(id, womeApplicationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


